var jt = Object.defineProperty;
var qt = (e, r, i) => r in e ? jt(e, r, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[r] = i;
var te = (e, r, i) => (qt(e, typeof r != "symbol" ? r + "" : r, i), i);
import { j as c, a as N, F as pe } from "./jsx-runtime.mjs";
import Te, { useState as O, useEffect as y, useMemo as U, useCallback as F, useImperativeHandle as Kt, useRef as j, cloneElement as Pt, useContext as G, createContext as Gt, forwardRef as zt } from "react";
import { b as $, a as Wt, c as ve, u as Zt, g as Xt, M as Yt } from "./index.mjs";
import { a as z, b as ut, p as a, e as mt, i as Jt, f as ht, h as Qt, s as we, g as Rt, d as L, j as er, m as tr, k as gt, l as rr } from "./config.mjs";
import { a as Y, M as Ft, u as nr } from "./index2.mjs";
import { linkTo as or, draggingScroll as lr, debounce as ar, throttle as ir, smoothScroll as bt } from "@vavt/util";
import cr from "medium-zoom";
import sr from "copy-to-clipboard";
import dr from "markdown-it";
import ur from "markdown-it-image-figures";
import mr from "markdown-it-task-lists";
import hr from "lru-cache";
import { minimalSetup as gr, EditorView as be } from "codemirror";
import { placeholder as br, EditorView as Ne, keymap as fr } from "@codemirror/view";
import { languages as pr } from "@codemirror/language-data";
import { markdown as vr } from "@codemirror/lang-markdown";
import { deleteLine as kr, indentWithTab as $r, undo as Cr, redo as wr } from "@codemirror/commands";
import { EditorSelection as re, EditorState as ke, Compartment as Tr, StateEffect as Nr } from "@codemirror/state";
import { indentUnit as yr, HighlightStyle as _t, syntaxHighlighting as Ot } from "@codemirror/language";
import { tags as g } from "@lezer/highlight";
import { autocompletion as xr } from "@codemirror/autocomplete";
const he = "onSave", ye = "changeCatalogVisible", Vt = "changeFullscreen", ft = "pageFullscreenChanged", pt = "fullscreenChanged", vt = "previewChanged", kt = "htmlPreviewChanged", $t = "catalogVisibleChanged", Bt = "textareaFocus", Sr = (e, r) => {
  const { modelValue: i } = e, { editorId: t } = r, [n, l] = O({
    // 是否已编译成html
    buildFinished: !1,
    // 存储当前最新的html
    html: ""
  });
  y(() => {
    const d = (o) => {
      l(() => ({
        buildFinished: !0,
        html: o
      }));
    };
    return $.on(t, {
      name: "buildFinished",
      callback: d
    }), () => {
      $.remove(t, "buildFinished", d);
    };
  }, []), y(() => {
    const d = () => {
      if (e.onSave) {
        const o = new Promise((m) => {
          if (n.buildFinished)
            m(n.html);
          else {
            const h = (u) => {
              m(u), $.remove(t, "buildFinished", h);
            };
            $.on(t, {
              name: "buildFinished",
              callback: h
            });
          }
        });
        e.onSave(e.modelValue, o);
      }
    };
    return $.on(t, {
      name: he,
      callback: d
    }), () => {
      $.remove(t, he, d);
    };
  }, [i, e, n.buildFinished, n.html]), y(() => {
    l((d) => ({
      ...d,
      buildFinished: !1
    }));
  }, [i]);
}, Hr = (e) => {
  var o, m, h, u, s, C;
  const { noPrettier: r, noUploadImg: i } = e, { editorExtensions: t } = z, n = r || !!((m = (o = z.editorExtensions) == null ? void 0 : o.prettier) != null && m.prettierInstance), l = r || !!((u = (h = z.editorExtensions) == null ? void 0 : h.prettier) != null && u.parserMarkdownInstance), d = i || !!((C = (s = z.editorExtensions) == null ? void 0 : s.cropper) != null && C.instance);
  y(() => {
    var f, k, T, M;
    const w = document.createElement("script"), v = document.createElement("script");
    w.src = ((f = t == null ? void 0 : t.prettier) == null ? void 0 : f.standaloneJs) || ut.main, w.id = `${a}-prettier`, v.src = ((k = t == null ? void 0 : t.prettier) == null ? void 0 : k.parserMarkdownJs) || ut.markdown, v.id = `${a}-prettierMD`;
    const b = document.createElement("link");
    b.rel = "stylesheet", b.href = ((T = t == null ? void 0 : t.cropper) == null ? void 0 : T.css) || mt.css, b.id = `${a}-cropperCss`;
    const p = document.createElement("script");
    p.src = ((M = t == null ? void 0 : t.cropper) == null ? void 0 : M.js) || mt.js, p.id = `${a}-cropper`, d || (Y(b), Y(p)), n || Y(w), l || Y(v);
  }, []), Lr(e);
}, Lr = ({ noIconfont: e }) => {
  y(() => {
    var i;
    const r = document.createElement("script");
    r.src = ((i = z.editorExtensions) == null ? void 0 : i.iconfont) || Jt, r.id = `${a}-icon`, e || Y(r);
  }, []);
}, Mr = (e, r) => {
  y(() => ($.on(e, {
    name: "errorCatcher",
    callback: r
  }), () => {
    $.remove(e, "errorCatcher", r);
  }), [r]);
}, Ir = (e, r) => {
  const { editorId: i } = r;
  y(() => {
    const t = (n, l) => {
      const d = (o) => {
        $.emit(i, "replace", "image", {
          desc: "",
          urls: o
        }), l && l();
      };
      e.onUploadImg && e.onUploadImg(n, d);
    };
    return $.on(i, {
      name: "uploadImage",
      callback: t
    }), () => {
      $.remove(i, "uploadImage", t);
    };
  }, [e.onUploadImg]);
}, Er = (e, r) => {
  const { toolbars: i = Rt, toolbarsExclude: t = [] } = e, { editorId: n } = r, [l, d] = O(!1);
  return y(() => {
    $.on(n, {
      name: ye,
      callback: (m) => {
        d(m === void 0 ? (h) => !h : m);
      }
    });
  }, []), U(() => !t.includes("catalog") && i.includes("catalog") && l, [l, i, t]);
};
let Ct = "";
const Ar = (e) => {
  const {
    theme: r = L.theme,
    preview: i = L.preview,
    htmlPreview: t = L.htmlPreview,
    pageFullscreen: n = L.pageFullscreen,
    previewTheme: l = L.previewTheme,
    codeTheme: d = L.codeTheme,
    language: o = L.language,
    codeStyleReverse: m = L.codeStyleReverse,
    codeStyleReverseList: h = L.codeStyleReverseList
  } = e, u = U(() => {
    var k, T;
    const b = (T = (k = z) == null ? void 0 : k.editorExtensions) == null ? void 0 : T.highlight, p = {
      ...ht,
      ...b == null ? void 0 : b.css
    }, f = m && h.includes(l) ? "dark" : r;
    return {
      js: (b == null ? void 0 : b.js) || Qt,
      css: p[d] ? p[d][f] : ht.atom[f]
    };
  }, [m, h, l, r, d]), s = U(() => {
    var p, f;
    const b = {
      ...we,
      ...(f = (p = z) == null ? void 0 : p.editorConfig) == null ? void 0 : f.languageUserDefined
    };
    return b[o] ? b[o] : we["zh-CN"];
  }, [o]), [C, w] = O({
    pageFullscreen: n,
    fullscreen: !1,
    preview: i,
    htmlPreview: i ? !1 : t
  }), v = F((b, p) => {
    w((f) => {
      const k = {
        ...f,
        [b]: p === void 0 ? !f[b] : p
      };
      return b === "fullscreen" && (p || f.fullscreen ? k.fullscreen = !f[b] : k.fullscreen = f[b]), b === "preview" && k.preview ? k.htmlPreview = !1 : b === "htmlPreview" && k.htmlPreview && (k.preview = !1), k;
    });
  }, []);
  return y(() => {
    Ct = document.body.style.overflow;
  }, []), y(() => {
    C.pageFullscreen || C.fullscreen ? document.body.style.overflow = "hidden" : document.body.style.overflow = Ct;
  }, [C.pageFullscreen, C.fullscreen]), [u, s, C, v];
}, Dr = (e, r, i, t, n) => {
  const { editorId: l } = r;
  y(() => {
    $.emit(l, ft, t.pageFullscreen);
  }, [t.pageFullscreen]), y(() => {
    $.emit(l, pt, t.fullscreen);
  }, [t.fullscreen]), y(() => {
    $.emit(l, vt, t.preview);
  }, [t.preview]), y(() => {
    $.emit(l, kt, t.htmlPreview);
  }, [t.htmlPreview]), y(() => {
    $.emit(l, $t, i);
  }, [i]), Kt(
    e,
    () => ({
      on(o, m) {
        switch (o) {
          case "pageFullscreen": {
            $.on(l, {
              name: ft,
              callback(h) {
                m(h);
              }
            });
            break;
          }
          case "fullscreen": {
            $.on(l, {
              name: pt,
              callback(h) {
                m(h);
              }
            });
            break;
          }
          case "preview": {
            $.on(l, {
              name: vt,
              callback(h) {
                m(h);
              }
            });
            break;
          }
          case "htmlPreview": {
            $.on(l, {
              name: kt,
              callback(h) {
                m(h);
              }
            });
            break;
          }
          case "catalog": {
            $.on(l, {
              name: $t,
              callback(h) {
                m(h);
              }
            });
            break;
          }
        }
      },
      togglePageFullscreen(o) {
        n("pageFullscreen", o);
      },
      toggleFullscreen(o) {
        $.emit(l, Vt, o);
      },
      togglePreview(o) {
        n("preview", o);
      },
      toggleHtmlPreview(o) {
        n("htmlPreview", o);
      },
      toggleCatalog(o) {
        $.emit(l, ye, o);
      },
      triggerSave() {
        $.emit(l, he);
      },
      insert(o) {
        $.emit(l, "replace", "universal", { generate: o });
      },
      focus(o) {
        $.emit(l, Bt, o);
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
}, Pr = () => /* @__PURE__ */ c("div", { className: `${a}-divider` }), wt = `${a}-dropdown-hidden`, de = (e) => {
  const { relative: r = "html" } = e, [i, t] = O({
    overlayClass: wt,
    overlayStyle: {}
  }), n = j({
    triggerHover: !1,
    overlayHover: !1
  }), l = j(null), d = j(null), o = F(() => {
    var D;
    n.current.triggerHover = !0;
    const b = l.current, p = d.current;
    if (!b || !p)
      return;
    const f = b.getBoundingClientRect(), k = b.offsetTop, T = b.offsetLeft, M = f.height, x = f.width, H = ((D = document.querySelector(r)) == null ? void 0 : D.scrollLeft) || 0;
    t((R) => ({
      ...R,
      overlayStyle: {
        top: k + M + "px",
        left: T - p.offsetWidth / 2 + x / 2 - H + "px"
      }
    })), e.onChange(!0);
  }, [e, r]), m = () => {
    n.current.overlayHover = !0;
  };
  y(() => {
    e.visible ? t((b) => ({
      ...b,
      overlayClass: ""
    })) : t((b) => ({
      ...b,
      overlayClass: wt
    }));
  }, [e.visible]);
  const h = j(-1), u = F(
    (b) => {
      l.current === b.target ? n.current.triggerHover = !1 : n.current.overlayHover = !1, clearTimeout(h.current), h.current = window.setTimeout(() => {
        !n.current.overlayHover && !n.current.triggerHover && e.onChange(!1);
      }, 10);
    },
    [e]
  );
  y(() => {
    var b, p, f, k;
    return (b = l.current) == null || b.addEventListener("mouseenter", o), (p = l.current) == null || p.addEventListener("mouseleave", u), (f = d.current) == null || f.addEventListener("mouseenter", m), (k = d.current) == null || k.addEventListener("mouseleave", u), () => {
      var T, M, x, H;
      (T = l.current) == null || T.removeEventListener("mouseenter", o), (M = l.current) == null || M.removeEventListener("mouseleave", u), (x = d.current) == null || x.removeEventListener("mouseenter", m), (H = d.current) == null || H.removeEventListener("mouseleave", u);
    };
  }, [u, o]);
  const s = e.children, C = e.overlay, w = Pt(s, {
    ref: l
  }), v = /* @__PURE__ */ c(
    "div",
    {
      className: `${a}-dropdown ${i.overlayClass}`,
      style: i.overlayStyle,
      ref: d,
      children: /* @__PURE__ */ c("div", { className: `${a}-dropdown-overlay`, children: C instanceof Array ? C[0] : C })
    }
  );
  return /* @__PURE__ */ N(pe, { children: [
    w,
    v
  ] });
}, Rr = (e) => {
  var d, o, m, h, u;
  const { editorId: r, usedLanguageText: i } = G(q), t = U(() => {
    var s, C;
    switch (e.type) {
      case "link":
        return (s = i.linkModalTips) == null ? void 0 : s.linkTitle;
      case "image":
        return (C = i.linkModalTips) == null ? void 0 : C.imageTitle;
      default:
        return "";
    }
  }, [e.type, i]), [n, l] = O({
    desc: "",
    url: ""
  });
  return y(() => {
    e.visible || setTimeout(() => {
      l({
        desc: "",
        url: ""
      });
    }, 200);
  }, [e.visible]), U(() => {
    var s, C, w, v, b;
    return /* @__PURE__ */ N(Ft, { title: t, visible: e.visible, onClose: e.onCancel, children: [
      /* @__PURE__ */ N("div", { className: `${a}-form-item`, children: [
        /* @__PURE__ */ c("label", { className: `${a}-label`, htmlFor: `link-desc-${r}`, children: (s = i.linkModalTips) == null ? void 0 : s.descLabel }),
        /* @__PURE__ */ c(
          "input",
          {
            placeholder: (C = i.linkModalTips) == null ? void 0 : C.descLabelPlaceHolder,
            className: `${a}-input`,
            id: `link-desc-${r}`,
            type: "text",
            value: n.desc,
            onChange: (p) => {
              l((f) => ({
                ...f,
                desc: p.target.value
              }));
            }
          }
        )
      ] }),
      /* @__PURE__ */ N("div", { className: `${a}-form-item`, children: [
        /* @__PURE__ */ c("label", { className: `${a}-label`, htmlFor: `link-url-${r}`, children: (w = i.linkModalTips) == null ? void 0 : w.urlLabel }),
        /* @__PURE__ */ c(
          "input",
          {
            placeholder: (v = i.linkModalTips) == null ? void 0 : v.urlLabelPlaceHolder,
            className: `${a}-input`,
            id: `link-url-${r}`,
            type: "text",
            value: n.url,
            onChange: (p) => {
              l((f) => ({
                ...f,
                url: p.target.value
              }));
            }
          }
        )
      ] }),
      /* @__PURE__ */ c("div", { className: `${a}-form-item`, children: /* @__PURE__ */ c(
        "button",
        {
          className: `${a}-btn ${a}-btn-row`,
          type: "button",
          onClick: () => {
            e.onOk(n), l((p) => ({
              ...p,
              desc: "",
              url: ""
            }));
          },
          children: (b = i.linkModalTips) == null ? void 0 : b.buttonOK
        }
      ) })
    ] });
  }, [
    t,
    e,
    (d = i.linkModalTips) == null ? void 0 : d.descLabel,
    (o = i.linkModalTips) == null ? void 0 : o.descLabelPlaceHolder,
    (m = i.linkModalTips) == null ? void 0 : m.urlLabel,
    (h = i.linkModalTips) == null ? void 0 : h.urlLabelPlaceHolder,
    (u = i.linkModalTips) == null ? void 0 : u.buttonOK,
    n
  ]);
}, Fr = Rr;
let ee = null;
const _r = (e) => {
  var w, v, b, p;
  const r = G(q), { editorId: i, usedLanguageText: t } = r, n = (v = (w = z.editorExtensions) == null ? void 0 : w.cropper) == null ? void 0 : v.instance, l = j(null), d = j(null), o = j(null), [m, h] = O({
    cropperInited: !1,
    imgSelected: !1,
    imgSrc: "",
    // 是否全屏
    isFullscreen: !1
  });
  y(() => {
    e.visible && !m.cropperInited && (window.Cropper = n || window.Cropper, l.current.onchange = () => {
      if (!window.Cropper) {
        $.emit(i, "errorCatcher", {
          name: "Cropper",
          message: "Cropper is undefined"
        });
        return;
      }
      const f = l.current.files || [];
      if ((f == null ? void 0 : f.length) > 0) {
        const k = new FileReader();
        k.onload = (T) => {
          h((M) => ({
            ...M,
            imgSelected: !0,
            imgSrc: T.target.result
          }));
        }, k.readAsDataURL(f[0]);
      }
    });
  }, [e.visible, m.cropperInited]), y(() => {
    m.imgSrc && (ee = new window.Cropper(d.current, {
      viewMode: 2,
      preview: `.${a}-clip-preview-target`
      // aspectRatio: 16 / 9,
    }));
  }, [m.imgSrc]), y(() => {
    var f;
    (f = o.current) == null || f.setAttribute("style", "");
  }, [m.imgSelected]), y(() => {
    var f;
    ee == null || ee.destroy(), (f = o.current) == null || f.setAttribute("style", ""), d.current && (ee = new window.Cropper(d.current, {
      viewMode: 2,
      preview: `.${a}-clip-preview-target`
      // aspectRatio: 16 / 9,
    }));
  }, [m.isFullscreen]);
  const u = U(() => m.isFullscreen ? {
    width: "100%",
    height: "100%"
  } : {
    width: "668px",
    height: "392px"
  }, [m.isFullscreen]), s = () => {
    ee.clear(), ee.destroy(), ee = null, l.current.value = "", h((f) => ({
      ...f,
      imgSrc: "",
      imgSelected: !1
    }));
  }, C = F((f) => {
    h((k) => ({
      ...k,
      isFullscreen: f
    }));
  }, []);
  return U(() => {
    var f, k;
    return /* @__PURE__ */ N(
      Ft,
      {
        className: `${a}-modal-clip`,
        title: (f = t.clipModalTips) == null ? void 0 : f.title,
        visible: e.visible,
        onClose: e.onCancel,
        showAdjust: !0,
        isFullscreen: m.isFullscreen,
        onAdjust: C,
        ...u,
        children: [
          /* @__PURE__ */ N("div", { className: `${a}-form-item ${a}-clip`, children: [
            /* @__PURE__ */ c("div", { className: `${a}-clip-main`, children: m.imgSelected ? /* @__PURE__ */ N("div", { className: `${a}-clip-cropper`, children: [
              /* @__PURE__ */ c(
                "img",
                {
                  src: m.imgSrc,
                  ref: d,
                  style: { display: "none" },
                  alt: ""
                }
              ),
              /* @__PURE__ */ c("div", { className: `${a}-clip-delete`, onClick: s, children: /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-delete" }) }) })
            ] }) : /* @__PURE__ */ c(
              "div",
              {
                className: `${a}-clip-upload`,
                onClick: () => {
                  l.current.click();
                },
                children: /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-upload" }) })
              }
            ) }),
            /* @__PURE__ */ c("div", { className: `${a}-clip-preview`, children: /* @__PURE__ */ c("div", { className: `${a}-clip-preview-target`, ref: o }) })
          ] }),
          /* @__PURE__ */ c("div", { className: `${a}-form-item`, children: /* @__PURE__ */ c(
            "button",
            {
              className: `${a}-btn`,
              type: "button",
              onClick: () => {
                if (ee) {
                  const T = ee.getCroppedCanvas();
                  $.emit(
                    i,
                    "uploadImage",
                    [Wt(T.toDataURL("image/png"))],
                    e.onOk
                  ), s();
                }
              },
              children: (k = t.linkModalTips) == null ? void 0 : k.buttonOK
            }
          ) }),
          /* @__PURE__ */ c(
            "input",
            {
              ref: l,
              accept: "image/*",
              type: "file",
              multiple: !1,
              style: { display: "none" }
            }
          )
        ]
      }
    );
  }, [
    (b = t.clipModalTips) == null ? void 0 : b.title,
    (p = t.linkModalTips) == null ? void 0 : p.buttonOK,
    e.visible,
    e.onCancel,
    e.onOk,
    m.isFullscreen,
    m.imgSelected,
    m.imgSrc,
    C,
    u
  ]);
}, Or = _r, Vr = (e) => /* @__PURE__ */ N(pe, { children: [
  /* @__PURE__ */ c(
    Fr,
    {
      type: e.type,
      visible: e.linkVisible,
      onOk: e.onOk,
      onCancel: e.onCancel
    }
  ),
  /* @__PURE__ */ c(
    Or,
    {
      visible: e.clipVisible,
      onOk: e.onOk,
      onCancel: e.onCancel
    }
  )
] }), Br = Vr, Ur = (e) => {
  const [r, i] = O({
    x: -1,
    y: -1
  });
  return /* @__PURE__ */ c(
    "div",
    {
      className: `${a}-table-shape`,
      onMouseLeave: () => {
        i({
          x: -1,
          y: -1
        });
      },
      children: new Array(e.tableShape[1]).fill("").map((t, n) => /* @__PURE__ */ c("div", { className: `${a}-table-shape-row`, children: new Array(e.tableShape[0]).fill("").map((l, d) => /* @__PURE__ */ c(
        "div",
        {
          className: `${a}-table-shape-col`,
          onMouseEnter: () => {
            i({
              x: n,
              y: d
            });
          },
          onClick: () => {
            e.onSelected(r);
          },
          children: /* @__PURE__ */ c(
            "div",
            {
              className: [
                `${a}-table-shape-col-default`,
                n <= r.x && d <= r.y && `${a}-table-shape-col-include`
              ].filter((o) => !!o).join(" ")
            }
          )
        },
        `table-shape-col-${d}`
      )) }, `table-shape-row-${n}`))
    }
  );
}, jr = Ur, qr = (e) => {
  var d;
  const { editorId: r } = G(q), i = (d = z.editorExtensions) == null ? void 0 : d.screenfull;
  let t = i == null ? void 0 : i.instance;
  const n = j(!1), l = F(
    (o) => {
      if (!t) {
        $.emit(r, "errorCatcher", {
          name: "fullscreen",
          message: "fullscreen is undefined"
        });
        return;
      }
      t.isEnabled ? (n.current = !0, (o === void 0 ? !t.isFullscreen : o) ? t.request() : t.exit()) : console.error("browser does not support screenfull!");
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return y(() => {
    let o;
    t || (o = document.createElement("script"), o.src = (i == null ? void 0 : i.js) || er, o.onload = () => {
      t = window.screenfull, t && t.isEnabled && t.on("change", () => {
        e.updateSetting("fullscreen", n.current), n.current && (n.current = !1);
      });
    }, o.id = `${a}-screenfull`, Y(o, "screenfull")), t && t.isEnabled && t.on("change", () => {
      e.updateSetting("fullscreen", n.current), n.current && (n.current = !1);
    });
  }, []), y(() => {
    $.on(r, {
      name: Vt,
      callback: l
    });
  }, []), { fullscreenHandler: l };
}, Kr = (e, r) => {
  const { editorId: i } = G(q), [t, n] = O({
    type: "link",
    linkVisible: !1,
    clipVisible: !1
  }), l = F(() => {
    n((o) => ({
      ...o,
      linkVisible: !1,
      clipVisible: !1
    }));
  }, []), d = F(
    (o) => {
      o && r(t.type, {
        desc: o.desc,
        url: o.url
      }), l();
    },
    [r, t.type, l]
  );
  return y(() => {
    $.on(i, {
      name: "openModals",
      callback(m) {
        n((h) => ({
          ...h,
          type: m,
          linkVisible: !0
        }));
      }
    });
    const o = () => {
      $.emit(
        i,
        "uploadImage",
        Array.from(e.current.files || [])
      ), e.current.value = "";
    };
    e.current.addEventListener("change", o);
  }, []), {
    modalData: t,
    setModalData: n,
    onCancel: l,
    onOk: d
  };
}, Gr = (e) => {
  const [r, i] = O({
    title: !1,
    catalog: !1,
    // 图片上传下拉
    image: !1,
    // 表格预选
    table: !1,
    // mermaid
    mermaid: !1,
    katex: !1
  }), t = F((w) => {
    i((v) => ({
      ...v,
      title: w
    }));
  }, []), n = F(() => {
    i((w) => ({
      ...w,
      title: !1
    }));
  }, []), l = F((w) => {
    i((v) => ({
      ...v,
      image: w
    }));
  }, []), d = F(() => {
    i((w) => ({
      ...w,
      image: !1
    }));
  }, []), o = F((w) => {
    i((v) => ({
      ...v,
      table: w
    }));
  }, []), m = F(
    (w) => {
      e("table", { selectedShape: w });
    },
    [e]
  ), h = F((w) => {
    i((v) => ({
      ...v,
      mermaid: w
    }));
  }, []), u = F(() => {
    i((w) => ({
      ...w,
      mermaid: !1
    }));
  }, []), s = F((w) => {
    i((v) => ({
      ...v,
      katex: w
    }));
  }, []), C = F(() => {
    i((w) => ({
      ...w,
      katex: !1
    }));
  }, []);
  return {
    visible: r,
    onTitleChange: t,
    onTitleClose: n,
    onImageChange: l,
    onImageClose: d,
    onTableChange: o,
    onTableSelected: m,
    onMermaidChange: h,
    onMermaidClose: u,
    onKatexChange: s,
    onKatexClose: C
  };
};
let zr = 0;
const Wr = (e) => {
  const { toolbars: r, toolbarsExclude: i, setting: t, updateSetting: n } = e, { editorId: l, usedLanguageText: d } = G(q), o = d, [m] = O(() => `${l}-toolbar-wrapper`), h = j(null), u = j(null), s = F((S, I) => {
    $.emit(l, "replace", S, I);
  }, []), { fullscreenHandler: C } = qr(e), { modalData: w, setModalData: v, onCancel: b, onOk: p } = Kr(u, s), {
    visible: f,
    onTitleChange: k,
    onTitleClose: T,
    onImageChange: M,
    onImageClose: x,
    onTableChange: H,
    onTableSelected: D,
    onMermaidChange: R,
    onMermaidClose: _,
    onKatexChange: K,
    onKatexClose: V
  } = Gr(s), E = U(() => {
    var S, I, A, P, B, W, oe, le;
    return /* @__PURE__ */ c(
      de,
      {
        relative: `#${m}`,
        visible: f.title,
        onChange: k,
        overlay: /* @__PURE__ */ N("ul", { className: `${a}-menu`, onClick: T, children: [
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("h1");
              },
              children: (S = o.titleItem) == null ? void 0 : S.h1
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("h2");
              },
              children: (I = o.titleItem) == null ? void 0 : I.h2
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("h3");
              },
              children: (A = o.titleItem) == null ? void 0 : A.h3
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("h4");
              },
              children: (P = o.titleItem) == null ? void 0 : P.h4
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("h5");
              },
              children: (B = o.titleItem) == null ? void 0 : B.h5
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("h6");
              },
              children: (W = o.titleItem) == null ? void 0 : W.h6
            }
          )
        ] }),
        children: /* @__PURE__ */ N("div", { className: `${a}-toolbar-item`, title: (oe = o.toolbarTips) == null ? void 0 : oe.title, children: [
          /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-title" }) }),
          e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (le = o.toolbarTips) == null ? void 0 : le.title })
        ] })
      },
      "bar-title"
    );
  }, [
    m,
    f.title,
    k,
    T,
    o.titleItem,
    o.toolbarTips,
    e.showToolbarName,
    s
  ]), Z = U(() => {
    var S, I, A, P, B;
    return /* @__PURE__ */ c(
      de,
      {
        relative: `#${m}`,
        visible: f.image,
        onChange: M,
        overlay: /* @__PURE__ */ N("ul", { className: `${a}-menu`, onClick: x, children: [
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                v((W) => ({
                  ...W,
                  type: "image",
                  linkVisible: !0
                }));
              },
              children: (S = o.imgTitleItem) == null ? void 0 : S.link
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                u.current.click();
              },
              children: (I = o.imgTitleItem) == null ? void 0 : I.upload
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                v((W) => ({
                  ...W,
                  type: "image",
                  clipVisible: !0
                }));
              },
              children: (A = o.imgTitleItem) == null ? void 0 : A.clip2upload
            }
          )
        ] }),
        children: /* @__PURE__ */ N("div", { className: `${a}-toolbar-item`, title: (P = o.toolbarTips) == null ? void 0 : P.image, children: [
          /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-image" }) }),
          e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (B = o.toolbarTips) == null ? void 0 : B.image })
        ] })
      },
      "bar-image"
    );
  }, [
    m,
    f.image,
    M,
    x,
    o.imgTitleItem,
    o.toolbarTips,
    e.showToolbarName,
    v
  ]), X = U(() => {
    var S, I;
    return /* @__PURE__ */ c(
      de,
      {
        relative: `#${m}`,
        visible: f.table,
        onChange: H,
        overlay: /* @__PURE__ */ c(jr, { tableShape: e.tableShape, onSelected: D }),
        children: /* @__PURE__ */ N("div", { className: `${a}-toolbar-item`, title: (S = o.toolbarTips) == null ? void 0 : S.table, children: [
          /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-table" }) }),
          e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (I = o.toolbarTips) == null ? void 0 : I.table })
        ] })
      },
      "bar-table"
    );
  }, [
    m,
    f.table,
    H,
    e.tableShape,
    e.showToolbarName,
    D,
    o.toolbarTips
  ]), ae = U(() => {
    var S, I, A, P, B, W, oe, le, ce, se;
    return /* @__PURE__ */ c(
      de,
      {
        relative: `#${m}`,
        visible: f.mermaid,
        onChange: R,
        overlay: /* @__PURE__ */ N("ul", { className: `${a}-menu`, onClick: _, children: [
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("flow");
              },
              children: (S = o.mermaid) == null ? void 0 : S.flow
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("sequence");
              },
              children: (I = o.mermaid) == null ? void 0 : I.sequence
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("gantt");
              },
              children: (A = o.mermaid) == null ? void 0 : A.gantt
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("class");
              },
              children: (P = o.mermaid) == null ? void 0 : P.class
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("state");
              },
              children: (B = o.mermaid) == null ? void 0 : B.state
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("pie");
              },
              children: (W = o.mermaid) == null ? void 0 : W.pie
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("relationship");
              },
              children: (oe = o.mermaid) == null ? void 0 : oe.relationship
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("journey");
              },
              children: (le = o.mermaid) == null ? void 0 : le.journey
            }
          )
        ] }),
        children: /* @__PURE__ */ N("div", { className: `${a}-toolbar-item`, title: (ce = o.toolbarTips) == null ? void 0 : ce.mermaid, children: [
          /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-mermaid" }) }),
          e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (se = o.toolbarTips) == null ? void 0 : se.mermaid })
        ] })
      },
      "bar-mermaid"
    );
  }, [
    m,
    f.mermaid,
    R,
    _,
    o.mermaid,
    o.toolbarTips,
    e.showToolbarName,
    s
  ]), ne = U(() => {
    var S, I, A, P;
    return /* @__PURE__ */ c(
      de,
      {
        relative: `#${m}`,
        visible: f.katex,
        onChange: K,
        overlay: /* @__PURE__ */ N("ul", { className: `${a}-menu`, onClick: V, children: [
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("katexInline");
              },
              children: (S = o.katex) == null ? void 0 : S.inline
            }
          ),
          /* @__PURE__ */ c(
            "li",
            {
              className: `${a}-menu-item`,
              onClick: () => {
                s("katexBlock");
              },
              children: (I = o.katex) == null ? void 0 : I.block
            }
          )
        ] }),
        children: /* @__PURE__ */ N("div", { className: `${a}-toolbar-item`, title: (A = o.toolbarTips) == null ? void 0 : A.katex, children: [
          /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-formula" }) }),
          e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (P = o.toolbarTips) == null ? void 0 : P.katex })
        ] })
      },
      "bar-katex"
    );
  }, [
    m,
    f.katex,
    K,
    V,
    o.katex,
    o.toolbarTips,
    e.showToolbarName,
    s
  ]), J = F(
    (S) => {
      var I, A, P, B, W, oe, le, ce, se, xe, Se, He, Le, Me, Ie, Ee, Ae, De, Pe, Re, Fe, _e, Oe, Ve, Be, Ue, je, qe, Ke, Ge, ze, We, Ze, Xe, Ye, Je, Qe, et, tt, rt, nt, ot, lt, at, it, ct, st, dt;
      if (Rt.includes(S))
        switch (S) {
          case "-":
            return /* @__PURE__ */ c(Pr, {}, `bar-${zr++}`);
          case "bold":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (I = o.toolbarTips) == null ? void 0 : I.bold,
                onClick: () => {
                  s("bold");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-bold" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (A = o.toolbarTips) == null ? void 0 : A.bold })
                ]
              },
              "bar-bold"
            );
          case "underline":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (P = o.toolbarTips) == null ? void 0 : P.underline,
                onClick: () => {
                  s("underline");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-underline" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (B = o.toolbarTips) == null ? void 0 : B.underline })
                ]
              },
              "bar-underline"
            );
          case "italic":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (W = o.toolbarTips) == null ? void 0 : W.italic,
                onClick: () => {
                  s("italic");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-italic" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (oe = o.toolbarTips) == null ? void 0 : oe.italic })
                ]
              },
              "bar-italic"
            );
          case "strikeThrough":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (le = o.toolbarTips) == null ? void 0 : le.strikeThrough,
                onClick: () => {
                  s("strikeThrough");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-strike-through" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (ce = o.toolbarTips) == null ? void 0 : ce.strikeThrough })
                ]
              },
              "bar-strikeThrough"
            );
          case "title":
            return E;
          case "sub":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (se = o.toolbarTips) == null ? void 0 : se.sub,
                onClick: () => {
                  s("sub");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-sub" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (xe = o.toolbarTips) == null ? void 0 : xe.sub })
                ]
              },
              "bar-sub"
            );
          case "sup":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Se = o.toolbarTips) == null ? void 0 : Se.sup,
                onClick: () => {
                  s("sup");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-sup" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (He = o.toolbarTips) == null ? void 0 : He.sup })
                ]
              },
              "bar-sup"
            );
          case "quote":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Le = o.toolbarTips) == null ? void 0 : Le.quote,
                onClick: () => {
                  s("quote");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-quote" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (Me = o.toolbarTips) == null ? void 0 : Me.quote })
                ]
              },
              "bar-quote"
            );
          case "unorderedList":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Ie = o.toolbarTips) == null ? void 0 : Ie.unorderedList,
                onClick: () => {
                  s("unorderedList");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-unordered-list" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (Ee = o.toolbarTips) == null ? void 0 : Ee.unorderedList })
                ]
              },
              "bar-unorderedList"
            );
          case "orderedList":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Ae = o.toolbarTips) == null ? void 0 : Ae.orderedList,
                onClick: () => {
                  s("orderedList");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-ordered-list" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (De = o.toolbarTips) == null ? void 0 : De.orderedList })
                ]
              },
              "bar-orderedList"
            );
          case "task":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Pe = o.toolbarTips) == null ? void 0 : Pe.task,
                onClick: () => {
                  s("task");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-task" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (Re = o.toolbarTips) == null ? void 0 : Re.task })
                ]
              },
              "bar-task"
            );
          case "codeRow":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Fe = o.toolbarTips) == null ? void 0 : Fe.codeRow,
                onClick: () => {
                  s("codeRow");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-code-row" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (_e = o.toolbarTips) == null ? void 0 : _e.codeRow })
                ]
              },
              "bar-codeRow"
            );
          case "code":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Oe = o.toolbarTips) == null ? void 0 : Oe.code,
                onClick: () => {
                  s("code");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-code" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (Ve = o.toolbarTips) == null ? void 0 : Ve.code })
                ]
              },
              "bar-code"
            );
          case "link":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Be = o.toolbarTips) == null ? void 0 : Be.link,
                onClick: () => {
                  v({
                    ...w,
                    type: "link",
                    linkVisible: !0
                  });
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-link" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (Ue = o.toolbarTips) == null ? void 0 : Ue.link })
                ]
              },
              "bar-link"
            );
          case "image":
            return e.noUploadImg ? /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (je = o.toolbarTips) == null ? void 0 : je.image,
                onClick: () => {
                  v((ge) => ({
                    ...ge,
                    type: "image",
                    linkVisible: !0
                  }));
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-image" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (qe = o.toolbarTips) == null ? void 0 : qe.image })
                ]
              },
              "bar-image-no-upload"
            ) : Z;
          case "table":
            return X;
          case "revoke":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Ke = o.toolbarTips) == null ? void 0 : Ke.revoke,
                onClick: () => {
                  $.emit(l, "ctrlZ");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-revoke" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (Ge = o.toolbarTips) == null ? void 0 : Ge.revoke })
                ]
              },
              "bar-revoke"
            );
          case "next":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (ze = o.toolbarTips) == null ? void 0 : ze.next,
                onClick: () => {
                  $.emit(l, "ctrlShiftZ");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-next" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (We = o.toolbarTips) == null ? void 0 : We.next })
                ]
              },
              "bar-next"
            );
          case "save":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Ze = o.toolbarTips) == null ? void 0 : Ze.save,
                onClick: () => {
                  $.emit(l, he);
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-baocun" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (Xe = o.toolbarTips) == null ? void 0 : Xe.save })
                ]
              },
              "bar-save"
            );
          case "prettier":
            return e.noPrettier ? "" : /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Ye = o.toolbarTips) == null ? void 0 : Ye.prettier,
                onClick: () => {
                  s("prettier");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-prettier" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (Je = o.toolbarTips) == null ? void 0 : Je.prettier })
                ]
              },
              "bar-prettier"
            );
          case "pageFullscreen":
            return !t.fullscreen && /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (Qe = o.toolbarTips) == null ? void 0 : Qe.pageFullscreen,
                onClick: () => {
                  n("pageFullscreen");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c(
                    "use",
                    {
                      xlinkHref: `#md-editor-icon-${t.pageFullscreen ? "suoxiao" : "fangda"}`
                    }
                  ) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (et = o.toolbarTips) == null ? void 0 : et.pageFullscreen })
                ]
              },
              "bar-pageFullscreen"
            );
          case "fullscreen":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (tt = o.toolbarTips) == null ? void 0 : tt.fullscreen,
                onClick: () => {
                  C();
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c(
                    "use",
                    {
                      xlinkHref: `#md-editor-icon-${t.fullscreen ? "fullscreen-exit" : "fullscreen"}`
                    }
                  ) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (rt = o.toolbarTips) == null ? void 0 : rt.fullscreen })
                ]
              },
              "bar-fullscreen"
            );
          case "catalog":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (nt = o.toolbarTips) == null ? void 0 : nt.catalog,
                onClick: () => {
                  $.emit(l, ye);
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-catalog" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (ot = o.toolbarTips) == null ? void 0 : ot.catalog })
                ]
              },
              "bar-catalog"
            );
          case "preview":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (lt = o.toolbarTips) == null ? void 0 : lt.preview,
                onClick: () => {
                  n("preview");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-preview" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (at = o.toolbarTips) == null ? void 0 : at.preview })
                ]
              },
              "bar-preview"
            );
          case "htmlPreview":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (it = o.toolbarTips) == null ? void 0 : it.htmlPreview,
                onClick: () => {
                  n("htmlPreview");
                },
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-coding" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (ct = o.toolbarTips) == null ? void 0 : ct.htmlPreview })
                ]
              },
              "bar-htmlPreview"
            );
          case "github":
            return /* @__PURE__ */ N(
              "div",
              {
                className: `${a}-toolbar-item`,
                title: (st = o.toolbarTips) == null ? void 0 : st.github,
                onClick: () => or("https://github.com/imzbf/md-editor-rt"),
                children: [
                  /* @__PURE__ */ c("svg", { className: `${a}-icon`, "aria-hidden": "true", children: /* @__PURE__ */ c("use", { xlinkHref: "#md-editor-icon-github" }) }),
                  e.showToolbarName && /* @__PURE__ */ c("div", { className: `${a}-toolbar-item-name`, children: (dt = o.toolbarTips) == null ? void 0 : dt.github })
                ]
              },
              "bar-github"
            );
          case "mermaid":
            return ae;
          case "katex":
            return ne;
        }
      else if (e.defToolbars) {
        const ge = e.defToolbars[S];
        return ge ? Pt(ge, {
          insert(Ut) {
            $.emit(l, "replace", "universal", { generate: Ut });
          }
        }) : "";
      } else
        return "";
    },
    [
      e.defToolbars,
      e.showToolbarName,
      e.noUploadImg,
      e.noPrettier,
      o.toolbarTips,
      s,
      E,
      v,
      w,
      Z,
      X,
      l,
      t.fullscreen,
      t.pageFullscreen,
      n,
      C,
      ae,
      ne
    ]
  ), Q = U(() => {
    const S = r.filter((B) => !i.includes(B)), I = S.indexOf("="), A = I === -1 ? S : S.slice(0, I + 1), P = I === -1 ? [] : S.slice(I, Number.MAX_SAFE_INTEGER);
    return [
      A.map((B) => J(B)),
      P.map((B) => J(B))
    ];
  }, [r, i, J]);
  return y(() => {
    let S = () => {
    };
    return h.current && (S = lr(h.current)), () => {
      S();
    };
  }, [r]), /* @__PURE__ */ N(pe, { children: [
    r.length > 0 && /* @__PURE__ */ c("div", { className: `${a}-toolbar-wrapper`, ref: h, id: m, children: /* @__PURE__ */ N(
      "div",
      {
        className: ve([
          `${a}-toolbar`,
          e.showToolbarName && `${a}-stn`
        ]),
        children: [
          /* @__PURE__ */ c("div", { className: `${a}-toolbar-left`, children: Q[0] }),
          /* @__PURE__ */ c("div", { className: `${a}-toolbar-right`, children: Q[1] })
        ]
      }
    ) }),
    /* @__PURE__ */ c(
      "input",
      {
        ref: u,
        accept: "image/*",
        type: "file",
        multiple: !0,
        style: { display: "none" }
      }
    ),
    /* @__PURE__ */ c(
      Br,
      {
        linkVisible: w.linkVisible,
        clipVisible: w.clipVisible,
        type: w.type,
        onCancel: b,
        onOk: p
      }
    )
  ] });
}, Zr = Te.memo(Wr), Xr = (e, r) => {
  const i = ar(() => {
    e.removeEventListener("scroll", t), e.addEventListener("scroll", t), r.removeEventListener("scroll", t), r.addEventListener("scroll", t);
  }, 50), t = (n) => {
    const l = e.clientHeight, d = r.clientHeight, o = e.scrollHeight, m = r.scrollHeight, h = (o - l) / (m - d);
    n.target === e ? (r.removeEventListener("scroll", t), r.scrollTo({
      top: e.scrollTop / h
      // behavior: 'smooth'
    }), i()) : (e.removeEventListener("scroll", t), e.scrollTo({
      top: r.scrollTop * h
      // behavior: 'smooth'
    }), i());
  };
  return [
    () => {
      i().finally(() => {
        e.dispatchEvent(new Event("scroll"));
      });
    },
    () => {
      e.removeEventListener("scroll", t), r.removeEventListener("scroll", t);
    }
  ];
}, Yr = (e, r, i) => {
  const { view: t } = i, n = (s) => t.lineBlockAt(t.state.doc.line(s).from).top, l = (s) => t.lineBlockAt(t.state.doc.line(s).from).height;
  let d = [];
  const o = () => {
    d = [];
    const s = Array.from(r.querySelectorAll("[data-line]")).map(
      (b) => Number(b.dataset.line) + 1
    ), { lines: C } = t.state.doc;
    let w = 1, v = s.shift() ?? C;
    for (let b = 1; b <= C; b++)
      b === v && (w = b, v = s.shift() || C + 1), d.push({
        start: w,
        end: v - 1
      });
  };
  let m = 0, h = 0;
  const u = ir((s) => {
    var v, b, p, f, k, T, M;
    if (!((v = r.firstElementChild) != null && v.firstElementChild))
      return;
    const C = t.lineBlockAtHeight(t.scrollDOM.scrollTop), { number: w } = t.state.doc.lineAt(C.from);
    if (!(w > d.length) && !(t.state.doc.lines < d[d.length - 1].end))
      if (s.target === e) {
        if (h !== 0)
          return;
        m++;
        const x = d[w - 1], H = n(x.end) + l(x.end);
        let D = 0;
        const R = n(x.start), _ = r.querySelector(`[data-line="${x.start - 1}"]`) || ((b = r.firstElementChild) == null ? void 0 : b.firstElementChild), K = r.querySelector(`[data-line="${x.end}"]`) || ((p = r.lastElementChild) == null ? void 0 : p.lastElementChild);
        let V = 0, E = 0;
        R === 0 ? (D = (t.scrollDOM.scrollTop - R) / (H - R), V = K.offsetTop) : H > t.scrollDOM.scrollHeight - t.scrollDOM.clientHeight ? (D = (t.scrollDOM.scrollTop - R) / (t.scrollDOM.scrollHeight - t.scrollDOM.clientHeight - R), E = _.offsetTop, V = r.scrollHeight - r.clientHeight - E + 10) : (D = (t.scrollDOM.scrollTop - R) / (H - R), E = _.offsetTop, V = K.offsetTop - E);
        const Z = E - 10 + V * D;
        bt(r, Z, () => {
          m--;
        });
      } else {
        if (m !== 0)
          return;
        h++;
        const x = Array.from(
          r.querySelectorAll("[data-line]")
        ), H = r.scrollTop, D = r.scrollHeight;
        let R = x.length === 0 ? 1 : Math.ceil(
          Number(x[x.length - 1].dataset.line) * (H / D)
        ), _ = (f = r.firstElementChild) == null ? void 0 : f.firstElementChild;
        for (let A = R; A >= 0; A--) {
          const P = r.querySelector(`[data-line="${A}"]`);
          if (P && P.offsetTop <= H) {
            _ = P, R = A;
            break;
          }
        }
        let K = (k = r.firstElementChild) == null ? void 0 : k.firstElementChild, V = (T = r.firstElementChild) == null ? void 0 : T.lastElementChild;
        for (; x.length > 0; ) {
          const A = x.indexOf(_);
          if (A + 1 >= x.length)
            break;
          const P = x[A + 1];
          if (A === -1) {
            V = P;
            break;
          }
          const B = _.offsetTop;
          if (B > H) {
            if (A === 0) {
              K = _, V = P;
              break;
            }
            _ = x[A - 1];
            continue;
          }
          const W = P.offsetTop;
          if (B <= H && W > H) {
            K = _, V = P;
            break;
          }
          _ = P;
        }
        const E = K.offsetTop, Z = V.offsetTop;
        let X = 0;
        const { start: ae, end: ne } = d[Number(K.dataset.line || 0)], J = n(ae);
        let Q = n(ne);
        const S = l(ne);
        let I = 0;
        K === ((M = r.firstElementChild) == null ? void 0 : M.firstElementChild) ? (X = Math.max(H / Z, 0), I = Q + S - J) : Q > t.scrollDOM.scrollHeight - t.scrollDOM.clientHeight ? (X = Math.max(
          (H - E) / (r.scrollHeight - E - r.clientHeight),
          0
        ), Q = n(t.state.doc.lines) + l(t.state.doc.lines), I = 8 + Q - J - e.clientHeight) : (X = Math.max(
          (H - E) / (Z - E),
          0
        ), I = Q + S - J), bt(e, J + I * X, () => {
          h--;
        });
      }
  }, 10);
  return [
    () => {
      o(), e.addEventListener("scroll", u), r.addEventListener("scroll", u), e.dispatchEvent(new Event("scroll"));
    },
    () => {
      d = [], e.removeEventListener("scroll", u), r.removeEventListener("scroll", u);
    }
  ];
}, Jr = (e, r, i) => {
  const { editorId: t } = G(q), [n, l] = O({
    clear() {
    },
    init() {
    }
  });
  y(() => {
    n.clear();
    const d = document.querySelector(".cm-scroller"), o = document.querySelector(
      `[id="${t}-preview-wrapper"][data-show="true"]`
    ), m = document.querySelector(
      `[id="${t}-html-wrapper"][data-show="true"]`
    );
    if (o || m) {
      const h = o ? Yr : Xr, u = o || m, [s, C] = h(d, u, i.current);
      l({
        init: s,
        clear: C
      });
    }
  }, [
    r,
    e.setting.fullscreen,
    e.setting.pageFullscreen,
    e.setting.preview,
    e.setting.htmlPreview
  ]), y(() => (e.scrollAuto ? n.init() : n.clear(), () => {
    n.clear();
  }), [n, e.scrollAuto]);
}, Qr = Jr, en = (e, r, i) => {
  var u, s, C, w, v, b;
  let t = "", n = 0, l = 0, d = !0, o = !1;
  const m = r.getSelectedText(), h = (u = z.editorConfig) == null ? void 0 : u.mermaidTemplate;
  if (/^h[1-6]{1}$/.test(e)) {
    const p = e.replace(/^h(\d)/, (f, k) => new Array(Number(k)).fill("#", 0, k).join(""));
    t = `${p} ${m}`, n = p.length + 1;
  } else if (e === "prettier") {
    const p = window.prettier || ((C = (s = z.editorExtensions) == null ? void 0 : s.prettier) == null ? void 0 : C.prettierInstance), f = [
      ((w = window.prettierPlugins) == null ? void 0 : w.markdown) || ((b = (v = z.editorExtensions) == null ? void 0 : v.prettier) == null ? void 0 : b.parserMarkdownInstance)
    ];
    !p || f[0] === void 0 ? ($.emit(i.editorId, "errorCatcher", {
      name: "prettier",
      message: "prettier is undefined"
    }), t = r.getValue()) : t = p.format(r.getValue(), {
      parser: "markdown",
      plugins: f
    }), d = !1, o = !0;
  } else
    switch (e) {
      case "bold": {
        t = `**${m}**`, n = 2, l = -2;
        break;
      }
      case "underline": {
        t = `<u>${m}</u>`, n = 3, l = -4;
        break;
      }
      case "italic": {
        t = `*${m}*`, n = 1, l = -1;
        break;
      }
      case "strikeThrough": {
        t = `~~${m}~~`, n = 2, l = -2;
        break;
      }
      case "sub": {
        t = `<sub>${m}</sub>`, n = 5, l = -6;
        break;
      }
      case "sup": {
        t = `<sup>${m}</sup>`, n = 5, l = -6;
        break;
      }
      case "codeRow": {
        t = "`" + m + "`", n = 1, l = -1;
        break;
      }
      case "quote": {
        t = `> ${m}`, n = 2;
        break;
      }
      case "orderedList": {
        t = `1. ${m}`, n = 3;
        break;
      }
      case "unorderedList": {
        t = `- ${m}`, n = 2;
        break;
      }
      case "task": {
        t = `- [ ] ${m}`, n = 6;
        break;
      }
      case "code": {
        const p = i.text || m || "", f = i.mode || "language";
        t = `\`\`\`${f}
${p}
\`\`\`
`, n = 3, l = 3 + f.length - t.length;
        break;
      }
      case "table": {
        t = "|";
        const { selectedShape: p = { x: 1, y: 1 } } = i, { x: f, y: k } = p;
        for (let T = 0; T <= k; T++)
          t += " col |";
        t += `
|`;
        for (let T = 0; T <= k; T++)
          t += " - |";
        for (let T = 0; T <= f; T++) {
          t += `
|`;
          for (let M = 0; M <= k; M++)
            t += " content |";
        }
        n = 2, l = 5 - t.length;
        break;
      }
      case "link": {
        const { desc: p, url: f } = i;
        t = `[${p}](${f})`, d = !1;
        break;
      }
      case "image": {
        const { desc: p, url: f, urls: k } = i;
        k instanceof Array ? t = k.reduce((T, M) => T + `![${p}](${M})
`, "") : t = `![${p}](${f})
`, d = !1;
        break;
      }
      case "flow": {
        t = `\`\`\`mermaid
${(h == null ? void 0 : h.flow) || `flowchart TD 
  Start --> Stop`}
\`\`\`
`, n = 3, l = 10 - t.length;
        break;
      }
      case "sequence": {
        t = `\`\`\`mermaid
${(h == null ? void 0 : h.sequence) || `sequenceDiagram
  A->>B: hello!
  B-->>A: hi!
  A-)B: bye!`}
\`\`\`
`, n = 3, l = 10 - t.length;
        break;
      }
      case "gantt": {
        t = `\`\`\`mermaid
${(h == null ? void 0 : h.gantt) || `gantt
title A Gantt Diagram
dateFormat  YYYY-MM-DD
section Section
A task  :a1, 2014-01-01, 30d
Another task  :after a1, 20d`}
\`\`\`
`, n = 3, l = 10 - t.length;
        break;
      }
      case "class": {
        t = `\`\`\`mermaid
${(h == null ? void 0 : h.class) || `classDiagram
  class Animal
  Vehicle <|-- Car`}
\`\`\`
`, n = 3, l = 10 - t.length;
        break;
      }
      case "state": {
        t = `\`\`\`mermaid
${(h == null ? void 0 : h.state) || `stateDiagram-v2
  s1 --> s2`}
\`\`\`
`, n = 3, l = 10 - t.length;
        break;
      }
      case "pie": {
        t = `\`\`\`mermaid
${(h == null ? void 0 : h.pie) || `pie title Pets adopted by volunteers
  "Dogs" : 386
  "Cats" : 85
  "Rats" : 15`}
\`\`\`
`, n = 3, l = 10 - t.length;
        break;
      }
      case "relationship": {
        t = `\`\`\`mermaid
${(h == null ? void 0 : h.relationship) || `erDiagram
  CAR ||--o{ NAMED-DRIVER : allows
  PERSON ||--o{ NAMED-DRIVER : is`}
\`\`\`
`, n = 3, l = 10 - t.length;
        break;
      }
      case "journey": {
        t = `\`\`\`mermaid
${(h == null ? void 0 : h.journey) || `journey
  title My working day
  section Go to work
    Make tea: 5: Me
    Go upstairs: 3: Me
    Do work: 1: Me, Cat
  section Go home
    Go downstairs: 5: Me
    Sit down: 5: Me`}
\`\`\`
`, n = 3, l = 10 - t.length;
        break;
      }
      case "katexInline": {
        t = "$$", n = 1, l = -1;
        break;
      }
      case "katexBlock": {
        t = `$$

$$
`, n = 3, l = -4;
        break;
      }
      case "universal": {
        const { generate: p } = i, f = p(m);
        t = f.targetValue, d = f.select, n = f.deviationStart, l = f.deviationEnd;
      }
    }
  return {
    text: t,
    options: {
      // 是否选中
      select: d,
      // 选中时，开始位置的偏移量
      deviationStart: n,
      // 结束的偏移量
      deviationEnd: l,
      // 是否整个替换
      replaceAll: o
    }
  };
}, ie = (e) => {
  const r = new Tr();
  return (t) => (r.get(e.state) ? e.dispatch({ effects: r.reconfigure(t) }) : e.dispatch({
    effects: Nr.appendConfig.of(r.of(t))
  }), !0);
};
class tn {
  constructor(r) {
    te(this, "view");
    te(this, "maxLength", Number.MAX_SAFE_INTEGER);
    // 切换tabSize的执行方法。切换时，Compartment实例需要相同
    te(this, "toggleTabSize");
    te(this, "togglePlaceholder");
    /**
     * 设置全部的扩展
     */
    te(this, "setExtensions");
    te(this, "toggleDisabled");
    te(this, "toggleReadOnly");
    te(this, "toggleMaxlength");
    this.view = r, this.toggleTabSize = ie(this.view), this.togglePlaceholder = ie(this.view), this.setExtensions = ie(this.view), this.toggleDisabled = ie(this.view), this.toggleReadOnly = ie(this.view), this.toggleMaxlength = ie(this.view);
  }
  getValue() {
    return this.view.state.doc.toString();
  }
  /**
   * 设置内容
   *
   * @param insert 待插入内容
   * @param from 插入开始位置
   * @param to 插入结束位置
   */
  setValue(r, i = 0, t = this.view.state.doc.length) {
    this.view.dispatch({
      changes: {
        from: i,
        to: t,
        insert: r
      }
    });
  }
  /**
   * 获取选中的文本
   */
  getSelectedText() {
    const { from: r, to: i } = this.view.state.selection.main;
    return this.view.state.sliceDoc(r, i);
  }
  /**
   * 使用新的内容替换选中的内容
   *
   * @param text 待替换内容
   * @param options 替换后是否选中
   */
  replaceSelectedText(r, i = {
    // 是否选中
    select: !0,
    // 选中时，开始位置的偏移量
    deviationStart: 0,
    // 结束的偏移量
    deviationEnd: 0,
    // 直接替换所有文本
    replaceAll: !1
  }, t) {
    try {
      if (i.replaceAll) {
        if (this.setValue(r), r.length > this.maxLength)
          throw new Error("The input text is too long");
        return;
      }
      if (this.view.state.doc.length - this.getSelectedText().length + r.length > this.maxLength)
        throw new Error("The input text is too long");
      const { from: n } = this.view.state.selection.main;
      if (this.view.dispatch(this.view.state.replaceSelection(r)), i.select) {
        const l = n + r.length + i.deviationEnd;
        this.view.dispatch({
          selection: re.create(
            [
              re.range(n + i.deviationStart, l),
              re.cursor(l)
            ],
            1
          )
        });
      }
      this.view.focus();
    } catch (n) {
      if (n.message === "The input text is too long")
        $.emit(t, "errorCatcher", {
          name: "overlength",
          message: n.message,
          data: r
        });
      else
        throw n;
    }
  }
  /**
   * 设置tabSize
   *
   * @param tabSize 需要切换的大小
   */
  setTabSize(r) {
    this.toggleTabSize([
      ke.tabSize.of(r),
      yr.of(" ".repeat(r))
    ]);
  }
  /**
   * 设置placeholder
   *
   * @param t 目标内容
   */
  setPlaceholder(r) {
    this.togglePlaceholder(br(r));
  }
  focus(r) {
    if (this.view.focus(), !r)
      return;
    let i = 0, t = 0, n = 0;
    switch (r) {
      case "start":
        break;
      case "end": {
        i = t = n = this.getValue().length;
        break;
      }
      default:
        i = r.rangeAnchor || r.cursorPos, t = r.rangeHead || r.cursorPos, n = r.cursorPos;
    }
    this.view.dispatch({
      scrollIntoView: !0,
      selection: re.create(
        [re.range(i, t), re.cursor(n)],
        1
      )
    });
  }
  setDisabled(r) {
    this.toggleDisabled([Ne.editable.of(!r)]);
  }
  setReadOnly(r) {
    this.toggleReadOnly([ke.readOnly.of(r)]);
  }
  setMaxLength(r) {
    this.maxLength = r, this.toggleMaxlength([
      ke.changeFilter.of((i) => i.newDoc.length <= r)
    ]);
  }
}
const rn = "#e5c07b", Tt = "var(--md-color)", nn = "#56b6c2", on = "#ffffff", ue = "var(--md-color)", Nt = "#e5c07b", ln = "#e5c07b", an = "var(--md-color)", yt = "#d19a66", cn = "#c678dd", sn = "#21252b", dn = "#2c313a", xt = "var(--md-bk-color)", $e = "var(--md-bk-color)", un = "#ceedfa33", St = "#528bff", mn = Ne.theme(
  {
    "&": {
      color: ue,
      backgroundColor: xt
    },
    ".cm-content": {
      caretColor: St
    },
    ".cm-cursor, .cm-dropCursor": { borderLeftColor: St },
    "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: un },
    ".cm-panels": { backgroundColor: sn, color: ue },
    ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
    ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
    ".cm-searchMatch": {
      backgroundColor: "#72a1ff59",
      outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
      backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": { backgroundColor: "#ceedfa33" },
    ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
      backgroundColor: "#bad0f847"
    },
    ".cm-gutters": {
      backgroundColor: xt,
      color: ue,
      borderRight: "1px solid",
      borderColor: "var(--md-border-color)"
    },
    ".cm-activeLineGutter": {
      backgroundColor: dn
    },
    ".cm-foldPlaceholder": {
      backgroundColor: "transparent",
      border: "none",
      color: "#ddd"
    },
    ".cm-tooltip": {
      border: "1px solid var(--md-border-color)",
      backgroundColor: $e
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
      borderTopColor: $e,
      borderBottomColor: $e
    },
    ".cm-tooltip-autocomplete": {
      "& > ul > li[aria-selected]": {
        color: ue
      }
    }
  },
  { dark: !0 }
), hn = _t.define([
  { tag: g.keyword, color: cn },
  { tag: [g.name, g.deleted, g.character, g.propertyName, g.macroName], color: Tt },
  { tag: [g.function(g.variableName), g.labelName], color: ln },
  { tag: [g.color, g.constant(g.name), g.standard(g.name)], color: yt },
  { tag: [g.definition(g.name), g.separator], color: ue },
  {
    tag: [
      g.typeName,
      g.className,
      g.number,
      g.changed,
      g.annotation,
      g.modifier,
      g.self,
      g.namespace
    ],
    color: rn
  },
  {
    tag: [
      g.operator,
      g.operatorKeyword,
      g.url,
      g.escape,
      g.regexp,
      g.link,
      g.special(g.string)
    ],
    color: nn
  },
  { tag: [g.meta, g.comment], color: Nt },
  { tag: g.strong, fontWeight: "bold" },
  { tag: g.emphasis, fontStyle: "italic" },
  { tag: g.strikethrough, textDecoration: "line-through" },
  { tag: g.link, color: Nt, textDecoration: "underline" },
  { tag: g.heading, fontWeight: "bold", color: Tt },
  { tag: [g.atom, g.bool, g.special(g.variableName)], color: yt },
  { tag: [g.processingInstruction, g.string, g.inserted], color: an },
  { tag: g.invalid, color: on }
]), gn = [
  mn,
  Ot(hn)
], bn = "#e5c07b", Ht = "#3f4a54", fn = "#56b6c2", pn = "#fff", me = "#3f4a54", Lt = "#2d8cf0", vn = "#2d8cf0", kn = "#3f4a54", Mt = "#d19a66", $n = "#c678dd", Cn = "#21252b", wn = "#ceedfa33", It = "var(--md-bk-color)", Ce = "var(--md-bk-color)", Tn = "#bad5fa", Et = "#3f4a54", Nn = Ne.theme(
  {
    "&": {
      color: me,
      backgroundColor: It
    },
    ".cm-content": {
      caretColor: Et
    },
    ".cm-cursor, .cm-dropCursor": { borderLeftColor: Et },
    "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: Tn },
    ".cm-panels": { backgroundColor: Cn, color: me },
    ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
    ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
    ".cm-searchMatch": {
      backgroundColor: "#72a1ff59",
      outline: "1px solid #457dff"
    },
    ".cm-searchMatch.cm-searchMatch-selected": {
      backgroundColor: "#6199ff2f"
    },
    ".cm-activeLine": { backgroundColor: "#ceedfa33" },
    ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
    "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
      backgroundColor: "#bad0f847"
    },
    ".cm-gutters": {
      backgroundColor: It,
      color: me,
      borderRight: "1px solid",
      borderColor: "var(--md-border-color)"
    },
    ".cm-activeLineGutter": {
      backgroundColor: wn
    },
    ".cm-foldPlaceholder": {
      backgroundColor: "transparent",
      border: "none",
      color: "#ddd"
    },
    ".cm-tooltip": {
      border: "1px solid var(--md-border-color)",
      backgroundColor: Ce
    },
    ".cm-tooltip .cm-tooltip-arrow:before": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    },
    ".cm-tooltip .cm-tooltip-arrow:after": {
      borderTopColor: Ce,
      borderBottomColor: Ce
    },
    ".cm-tooltip-autocomplete": {
      "& > ul > li[aria-selected]": {
        color: me
      }
    }
  }
  // { dark: true }
), yn = _t.define([
  { tag: g.keyword, color: $n },
  { tag: [g.name, g.deleted, g.character, g.propertyName, g.macroName], color: Ht },
  { tag: [g.function(g.variableName), g.labelName], color: vn },
  { tag: [g.color, g.constant(g.name), g.standard(g.name)], color: Mt },
  { tag: [g.definition(g.name), g.separator], color: me },
  {
    tag: [
      g.typeName,
      g.className,
      g.number,
      g.changed,
      g.annotation,
      g.modifier,
      g.self,
      g.namespace
    ],
    color: bn
  },
  {
    tag: [
      g.operator,
      g.operatorKeyword,
      g.url,
      g.escape,
      g.regexp,
      g.link,
      g.special(g.string)
    ],
    color: fn
  },
  { tag: [g.meta, g.comment], color: Lt },
  { tag: g.strong, fontWeight: "bold" },
  { tag: g.emphasis, fontStyle: "italic" },
  { tag: g.strikethrough, textDecoration: "line-through" },
  { tag: g.link, color: Lt, textDecoration: "underline" },
  { tag: g.heading, fontWeight: "bold", color: Ht },
  { tag: [g.atom, g.bool, g.special(g.variableName)], color: Mt },
  { tag: [g.processingInstruction, g.string, g.inserted], color: kn },
  { tag: g.invalid, color: pn }
]), xn = [
  Nn,
  Ot(yn)
], fe = (e, r, i, t, n) => (l, d, o, m) => {
  const h = `${e}${r}`.slice(m - o);
  l.dispatch(l.state.replaceSelection(`${h}${i}${t}`));
  const u = o + d.label.length + (n === "title" ? i.length : 0);
  l.dispatch({
    selection: re.create(
      [
        re.range(
          o + d.label.length + (n === "title" ? 1 : -r.length),
          u
        ),
        re.cursor(u)
      ],
      1
    )
  }), l.focus();
}, At = (e) => (r, i, t, n) => {
  const l = e.slice(n - t);
  r.dispatch(r.state.replaceSelection(`${l} `));
}, Sn = (e) => {
  const r = (i) => {
    const t = i.matchBefore(
      /^#+|^-\s*\[*\s*\]*|`+|\[|!\[*|^\|\s?\|?|^\$\$?|!+\s*\w*/
    );
    return t === null || t.from == t.to && i.explicit ? null : {
      from: t.from,
      options: [
        // 标题
        ...["h1", "h2", "h3", "h4", "h5", "h6"].map((n, l) => {
          const d = new Array(l + 1).fill("#").join("");
          return {
            label: d,
            type: "text",
            apply: At(d)
          };
        }),
        // 任务列表
        ...["unchecked", "checked"].map((n) => {
          const l = n === "checked" ? "- [x]" : "- [ ]";
          return {
            label: l,
            type: "text",
            apply: At(l)
          };
        }),
        // 代码
        ...[
          ["`", ""],
          ["```", "language"],
          ["```mermaid\n", ""]
        ].map((n) => ({
          label: `${n[0]}${n[1]}`,
          type: "text",
          apply: fe(n[0], n[1], "", n[0] === "`" ? "`" : "\n```", "type")
        })),
        // 链接
        {
          label: "[]()",
          type: "text"
        },
        {
          label: "![]()",
          type: "text"
        },
        // 表格
        {
          label: "| |",
          type: "text",
          detail: "table",
          apply: `| col | col | col |
| - | - | - |
| content | content | content |
| content | content | content |`
        },
        // 公式
        {
          label: "$",
          type: "text",
          apply: fe("$", "", "", "$", "type")
        },
        {
          label: "$$",
          type: "text",
          apply: fe("$$", "", `
`, `
$$`, "title")
        },
        // 那啥？
        ...[
          "note",
          "abstract",
          "info",
          "tip",
          "success",
          "question",
          "warning",
          "failure",
          "danger",
          "bug",
          "example",
          "quote",
          "hint",
          "caution",
          "error",
          "attention"
        ].map((n) => ({
          label: `!!! ${n}`,
          type: "text",
          apply: fe("!!!", ` ${n}`, " Title", `

!!!`, "title")
        }))
      ]
    };
  };
  return xr({
    override: e ? [r, ...e] : [r]
  });
}, Hn = Sn, Ln = (e, r) => [
  {
    key: "Ctrl-b",
    mac: "Cmd-b",
    run: () => ($.emit(e, "replace", "bold"), !0)
  },
  {
    key: "Ctrl-d",
    mac: "Cmd-d",
    run: kr,
    preventDefault: !0
  },
  {
    key: "Ctrl-s",
    mac: "Cmd-s",
    run: (M) => ($.emit(e, he, M.state.doc.toString()), !0),
    shift: () => ($.emit(e, "replace", "strikeThrough"), !0)
  },
  {
    key: "Ctrl-u",
    mac: "Cmd-u",
    run: () => ($.emit(e, "replace", "underline"), !0),
    shift: () => ($.emit(e, "replace", "unorderedList"), !0)
  },
  {
    key: "Ctrl-i",
    mac: "Cmd-i",
    run: () => ($.emit(e, "replace", "italic"), !0),
    shift: () => ($.emit(e, "openModals", "image"), !0)
  },
  {
    key: "Ctrl-1",
    mac: "Cmd-1",
    run: () => ($.emit(e, "replace", "h1"), !0)
  },
  {
    key: "Ctrl-2",
    mac: "Cmd-2",
    run: () => ($.emit(e, "replace", "h2"), !0)
  },
  {
    key: "Ctrl-3",
    mac: "Cmd-3",
    run: () => ($.emit(e, "replace", "h3"), !0)
  },
  {
    key: "Ctrl-4",
    mac: "Cmd-4",
    run: () => ($.emit(e, "replace", "h4"), !0)
  },
  {
    key: "Ctrl-5",
    mac: "Cmd-5",
    run: () => ($.emit(e, "replace", "h5"), !0)
  },
  {
    key: "Ctrl-6",
    mac: "Cmd-6",
    run: () => ($.emit(e, "replace", "h6"), !0)
  },
  {
    key: "Ctrl-ArrowUp",
    mac: "Cmd-ArrowUp",
    run: () => ($.emit(e, "replace", "sup"), !0)
  },
  {
    key: "Ctrl-ArrowDown",
    mac: "Cmd-ArrowDown",
    run: () => ($.emit(e, "replace", "sub"), !0)
  },
  {
    key: "Ctrl-o",
    mac: "Cmd-o",
    run: () => ($.emit(e, "replace", "orderedList"), !0)
  },
  {
    key: "Ctrl-c",
    mac: "Cmd-c",
    shift: () => ($.emit(e, "replace", "code"), !0),
    any(M, x) {
      return (x.ctrlKey || x.metaKey) && x.altKey && x.code === "KeyC" ? ($.emit(e, "replace", "codeRow"), !0) : !1;
    }
  },
  {
    key: "Ctrl-l",
    mac: "Cmd-l",
    run: () => ($.emit(e, "openModals", "link"), !0)
  },
  {
    key: "Ctrl-f",
    mac: "Cmd-f",
    shift: () => r.noPrettier ? !1 : ($.emit(e, "replace", "prettier"), !0)
  },
  {
    any: (M, x) => (x.ctrlKey || x.metaKey) && x.altKey && x.shiftKey && x.code === "KeyT" ? ($.emit(e, "replace", "table"), !0) : !1
  }
], Mn = Ln, In = (e) => {
  const { editorId: r } = G(q);
  return F(
    (t) => {
      if (!t.clipboardData)
        return;
      if (t.clipboardData.files.length > 0) {
        const { files: l } = t.clipboardData;
        $.emit(
          r,
          "uploadImage",
          Array.from(l).filter((d) => /image\/.*/.test(d.type))
        ), t.preventDefault();
        return;
      }
      if (e.autoDetectCode && t.clipboardData.types.includes("vscode-editor-data")) {
        const l = JSON.parse(t.clipboardData.getData("vscode-editor-data"));
        $.emit(r, "replace", "code", {
          mode: l.mode,
          text: t.clipboardData.getData("text/plain")
        }), t.preventDefault();
        return;
      }
      const n = t.clipboardData.getData("text/plain");
      e.maxLength && n.length + e.value.length > e.maxLength && $.emit(r, "errorCatcher", {
        name: "overlength",
        message: "The input text is too long",
        data: n
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e.autoDetectCode, e.maxLength, e.value]
  );
}, En = In, An = (e) => {
  const { editorId: r } = G(q);
  $.on(r, {
    name: Bt,
    callback(i) {
      var t;
      (t = e.current) == null || t.focus(i);
    }
  });
}, Dn = An, Pn = (e) => {
  const { tabWidth: r, editorId: i, theme: t } = G(q), n = j(null), l = j(), [d] = O(() => Mn(i, e)), o = j(!0), m = En(e), h = U(() => [
    fr.of([...d, $r]),
    gr,
    vr({ codeLanguages: pr }),
    // 横向换行
    be.lineWrapping,
    be.updateListener.of((s) => {
      s.docChanged && e.onChange(s.state.doc.toString());
    }),
    be.domEventHandlers({
      paste: m,
      blur: e.onBlur,
      focus: e.onFocus,
      input: (s) => {
        e.onInput && e.onInput(s);
        const { data: C } = s;
        e.maxLength && e.value.length + C.length > e.maxLength && $.emit(i, "errorCatcher", {
          name: "overlength",
          message: "The input text is too long",
          data: C
        });
      }
    })
  ], [d, m, e]), u = U(() => z.codeMirrorExtensions(
    t,
    [
      ...h,
      t === "light" ? xn : gn,
      Hn(e.completions)
    ],
    [...d]
  ), [h, d, e.completions, t]);
  return y(() => {
    const s = new be({
      doc: e.value,
      parent: n.current
    }), C = new tn(s);
    return l.current = C, setTimeout(() => {
      C.setTabSize(r), C.setDisabled(e.disabled), C.setReadOnly(e.readOnly), C.setExtensions(u), e.placeholder && C.setPlaceholder(e.placeholder), typeof e.maxLength == "number" && C.setMaxLength(e.maxLength), e.autoFocus && s.focus(), o.current = !1;
    }, 0), $.on(i, {
      name: "ctrlZ",
      callback() {
        Cr(s);
      }
    }), $.on(i, {
      name: "ctrlShiftZ",
      callback() {
        wr(s);
      }
    }), $.on(i, {
      name: "replace",
      callback(w, v = {}) {
        var f;
        const { text: b, options: p } = en(w, l.current, v);
        (f = l.current) == null || f.replaceSelectedText(b, p, i);
      }
    }), () => {
      s.destroy(), o.current = !0;
    };
  }, []), y(() => {
    var s;
    o.current || (s = l.current) == null || s.setExtensions(u);
  }, [u]), y(() => {
    var s, C;
    ((s = l.current) == null ? void 0 : s.getValue()) !== e.value && ((C = l.current) == null || C.setValue(e.value));
  }, [e.value]), y(() => {
    var s;
    o.current || (s = l.current) == null || s.setTabSize(r);
  }, [r]), y(() => {
    var s;
    o.current || (s = l.current) == null || s.setPlaceholder(e.placeholder);
  }, [e.placeholder]), y(() => {
    var s;
    o.current || (s = l.current) == null || s.setDisabled(e.disabled);
  }, [e.disabled]), y(() => {
    var s;
    o.current || (s = l.current) == null || s.setDisabled(e.readOnly);
  }, [e.readOnly]), y(() => {
    var s;
    o.current || typeof e.maxLength == "number" && ((s = l.current) == null || s.setMaxLength(e.maxLength));
  }, [e.maxLength]), Dn(l), {
    inputWrapperRef: n,
    codeMirrorUt: l
  };
}, Rn = Pn, Fn = (e, r) => {
  const { editorId: i } = G(q);
  y(() => (() => {
    const n = document.querySelectorAll(`#${i}-preview img.md-zoom`), l = cr(n, {
      background: "#00000073"
    });
    return () => {
      l.detach();
    };
  })(), [r, e.setting]);
}, _n = Fn, On = (e, r) => {
  var l, d, o;
  const { editorId: i, usedLanguageText: t } = G(q), { formatCopiedText: n = (m) => m } = e;
  y(() => {
    e.setting.preview && document.querySelectorAll(`#${i} .${a}-preview pre`).forEach((m) => {
      var C, w;
      let h = -1;
      (C = m.querySelector(".copy-button")) == null || C.remove();
      const u = ((w = t.copyCode) == null ? void 0 : w.text) || "复制代码", s = document.createElement("span");
      s.setAttribute("class", "copy-button"), s.dataset.tips = u, s.innerHTML = `<svg class="${a}-icon" aria-hidden="true"><use xlink:href="#${a}-icon-copy"></use></svg>`, s.addEventListener("click", () => {
        var k, T;
        clearTimeout(h);
        const v = m.querySelector("code").innerText, b = sr(n(v)), p = ((k = t.copyCode) == null ? void 0 : k.successTips) || "已复制！", f = ((T = t.copyCode) == null ? void 0 : T.failTips) || "已复制！";
        s.dataset.tips = b ? p : f, h = window.setTimeout(() => {
          s.dataset.tips = u;
        }, 1500);
      }), m.appendChild(s);
    });
  }, [
    n,
    r,
    e.setting.preview,
    (l = t.copyCode) == null ? void 0 : l.failTips,
    (d = t.copyCode) == null ? void 0 : d.successTips,
    (o = t.copyCode) == null ? void 0 : o.text
  ]);
}, Vn = On, Bn = (e) => {
  var o;
  const r = (o = z.editorExtensions) == null ? void 0 : o.highlight, i = r == null ? void 0 : r.instance, { highlight: t } = G(q), n = j(i), [l, d] = O(!!i);
  return y(() => {
    nr(`${a}-hlCss`, "href", t.css);
  }, [t.css]), y(() => {
    if (!e.noHighlight && !n.current) {
      const m = document.createElement("script");
      m.src = t.js, m.onload = () => {
        n.current = window.hljs, d(!0);
      }, m.id = `${a}-hljs`, Y(m, "hljs");
      const h = document.createElement("link");
      h.rel = "stylesheet", h.href = t.css, h.id = `${a}-hlCss`, Y(h);
    }
  }, []), { hljsRef: n, hljsInited: l };
}, Un = Bn, jn = (e) => {
  const { theme: r } = G(q), { editorExtensions: i } = z, t = i == null ? void 0 : i.mermaid, n = j(t == null ? void 0 : t.instance), [l, d] = O(-1), [o] = O(
    () => new hr({
      max: 1e3,
      // 缓存10分钟
      ttl: 6e5
    })
  ), m = F(() => {
    o.clear();
    const u = n.current;
    !e.noMermaid && u && (u.initialize({
      startOnLoad: !1,
      theme: r === "dark" ? "dark" : "default"
    }), d((s) => s + 1));
  }, [r]);
  return y(m, [m]), y(() => {
    if (!e.noMermaid && !(t != null && t.instance)) {
      const u = (t == null ? void 0 : t.js) || tr;
      if (/\.mjs/.test(u))
        import(
          /* @vite-ignore */
          /* webpackIgnore: true */
          u
        ).then((s) => {
          n.current = s.default, m();
        });
      else {
        const s = document.createElement("script");
        s.id = `${a}-mermaid`, s.src = u, s.onload = () => {
          n.current = window.mermaid, m();
        }, Y(s, "mermaid");
      }
    }
  }, []), { mermaidRef: n, reRender: l, replaceMermaid: () => {
    if (!e.noMermaid && n.current) {
      const u = document.querySelectorAll(
        `div.${a}-mermaid`
      ), s = document.createElement("div");
      s.style.width = document.body.offsetWidth + "px", s.style.height = document.body.offsetHeight + "px", s.style.position = "fixed", s.style.zIndex = "-10000", s.style.top = "-10000";
      let C = u.length;
      C > 0 && document.body.appendChild(s), u.forEach(async (w) => {
        let v = o.get(w.innerText);
        if (!v) {
          const p = Zt(), f = n.current.renderAsync || n.current.render;
          let k = "";
          try {
            k = await f(p, w.innerText, s);
          } catch {
          }
          v = typeof k == "string" ? k : k.svg, o.set(w.innerText, v);
        }
        const b = document.createElement("p");
        b.className = `${a}-mermaid`, b.setAttribute("data-processed", ""), b.innerHTML = v, w.dataset.line !== void 0 && (b.dataset.line = w.dataset.line), w.replaceWith(b), --C === 0 && s.remove();
      });
    }
  } };
}, qn = jn, Kn = (e) => {
  var d;
  const r = (d = z.editorExtensions) == null ? void 0 : d.katex, i = r == null ? void 0 : r.instance, t = j(i), [n, l] = O(!!i);
  return y(() => {
    if (!e.noKatex && !t.current) {
      const o = document.createElement("script");
      o.src = (r == null ? void 0 : r.js) || gt.js, o.onload = () => {
        t.current = window.katex, l(!0);
      }, o.id = `${a}-katex`;
      const m = document.createElement("link");
      m.rel = "stylesheet", m.href = (r == null ? void 0 : r.css) || gt.css, m.id = `${a}-katexCss`, Y(o, "katex"), Y(m);
    }
  }), { katexRef: t, katexInited: n };
}, Gn = Kn, zn = (e, r) => {
  const i = e.renderer.rules.fence.bind(e.renderer.rules);
  e.renderer.rules.fence = (t, n, l, d, o) => {
    const m = t[n], h = m.content.trim();
    if (m.info === "mermaid") {
      let u;
      return t[n].map && t[n].level === 0 && (u = t[n].map[0], t[n].attrSet("data-line", String(u))), `<div class="${a}-mermaid" ${u !== void 0 ? "data-line=" + u : ""} data-mermaid-theme=${r.themeRef.current}>${h}</div>`;
    }
    return i(t, n, l, d, o);
  };
}, Wn = zn, Dt = (e, r) => {
  let i = !0, t = !0;
  const n = e.posMax, l = r > 0 ? e.src.charCodeAt(r - 1) : -1, d = r + 1 <= n ? e.src.charCodeAt(r + 1) : -1;
  return (l === 32 || l === 9 || d >= 48 && d <= 57) && (t = !1), (d === 32 || d === 9) && (i = !1), {
    can_open: i,
    can_close: t
  };
}, Zn = (e, r) => {
  let i, t, n, l;
  if (e.src[e.pos] !== "$")
    return !1;
  if (n = Dt(e, e.pos), !n.can_open)
    return r || (e.pending += "$"), e.pos += 1, !0;
  const d = e.pos + 1;
  for (i = d; (i = e.src.indexOf("$", i)) !== -1; ) {
    for (l = i - 1; e.src[l] === "\\"; )
      l -= 1;
    if ((i - l) % 2 == 1)
      break;
    i += 1;
  }
  return i === -1 ? (r || (e.pending += "$"), e.pos = d, !0) : i - d === 0 ? (r || (e.pending += "$$"), e.pos = d + 1, !0) : (n = Dt(e, i), n.can_close ? (r || (t = e.push("math_inline", "math", 0), t.markup = "$", t.content = e.src.slice(d, i)), e.pos = i + 1, !0) : (r || (e.pending += "$"), e.pos = d, !0));
}, Xn = (e, r, i, t) => {
  let n, l, d, o, m = !1, h = e.bMarks[r] + e.tShift[r], u = e.eMarks[r];
  if (h + 2 > u || e.src.slice(h, h + 2) !== "$$")
    return !1;
  if (h += 2, n = e.src.slice(h, u), t)
    return !0;
  for (n.trim().slice(-2) === "$$" && (n = n.trim().slice(0, -2), m = !0), d = r; !m && (d++, !(d >= i || (h = e.bMarks[d] + e.tShift[d], u = e.eMarks[d], h < u && e.tShift[d] < e.blkIndent))); )
    e.src.slice(h, u).trim().slice(-2) === "$$" && (o = e.src.slice(0, u).lastIndexOf("$$"), l = e.src.slice(h, o), m = !0);
  e.line = d + 1;
  const s = e.push("math_block", "math", 0);
  return s.block = !0, s.content = (n && n.trim() ? n + `
` : "") + e.getLines(r + 1, d, e.tShift[r], !0) + (l && l.trim() ? l : ""), s.map = [r, e.line], s.markup = "$$", !0;
}, Yn = (e, r) => {
  const i = (n) => {
    if (r.katexRef.current) {
      const l = r.katexRef.current.renderToString(n, {
        throwOnError: !1
      });
      return `<span class="${a}-katex-inline" data-processed>${l}</span>`;
    } else
      return `<span class="${a}-katex-inline">${n}</span>`;
  }, t = (n, l) => {
    if (r.katexRef.current) {
      const d = r.katexRef.current.renderToString(n, {
        throwOnError: !1,
        displayMode: !0
      });
      return `<p class="${a}-katex-block" data-line=${l} data-processed>${d}</p>`;
    } else
      return `<p class="${a}-katex-block" data-line=${l}>${n}</p>`;
  };
  e.inline.ruler.after("escape", "math_inline", Zn), e.block.ruler.after("blockquote", "math_block", Xn, {
    alt: ["paragraph", "reference", "blockquote", "list"]
  }), e.renderer.rules.math_inline = (n, l) => i(n[l].content), e.renderer.rules.math_block = (n, l) => t(n[l].content, n[l].map[0]) + `
`;
}, Jn = Yn, Qn = (e, r) => {
  r = r || {};
  const i = 3, t = r.marker || "!", n = t.charCodeAt(0), l = t.length;
  let d = "", o = "";
  const m = (u, s, C, w, v) => {
    const b = u[s];
    return b.type === "admonition_open" ? (u[s].attrPush([
      "class",
      `${a}-admonition ${a}-admonition-${b.info}`
    ]), u[s].attrSet("data-line", String(u[s].map[0]))) : b.type === "admonition_title_open" && u[s].attrPush(["class", `${a}-admonition-title`]), v.renderToken(u, s, C);
  }, h = (u) => {
    const s = u.trim().split(" ", 2);
    o = "", d = s[0], s.length > 1 && (o = u.substring(d.length + 2)), (o === "" || !o) && (o = d);
  };
  e.block.ruler.before(
    "code",
    "admonition",
    (u, s, C, w) => {
      let v, b, p, f = !1, k = u.bMarks[s] + u.tShift[s], T = u.eMarks[s];
      if (n !== u.src.charCodeAt(k))
        return !1;
      for (v = k + 1; v <= T && t[(v - k) % l] === u.src[v]; v++)
        ;
      const M = Math.floor((v - k) / l);
      if (M !== i)
        return !1;
      v -= (v - k) % l;
      const x = u.src.slice(k, v), H = u.src.slice(v, T);
      if (h(H), w)
        return !0;
      for (b = s; b++, !(b >= C || (k = u.bMarks[b] + u.tShift[b], T = u.eMarks[b], k < T && u.sCount[b] < u.blkIndent)); )
        if (n === u.src.charCodeAt(k) && !(u.sCount[b] - u.blkIndent >= 4)) {
          for (v = k + 1; v <= T && t[(v - k) % l] === u.src[v]; v++)
            ;
          if (!(Math.floor((v - k) / l) < M) && (v -= (v - k) % l, v = u.skipSpaces(v), !(v < T))) {
            f = !0;
            break;
          }
        }
      const D = u.parentType, R = u.lineMax;
      return u.parentType = "root", u.lineMax = b, p = u.push("admonition_open", "div", 1), p.markup = x, p.block = !0, p.info = d, p.map = [s, b], p = u.push("admonition_title_open", "p", 1), p.markup = x + " " + d, p.map = [s, b], p = u.push("inline", "", 0), p.content = o, p.map = [s, u.line - 1], p.children = [], p = u.push("admonition_title_close", "p", -1), p.markup = x + " " + d, u.md.block.tokenize(u, s + 1, b), p = u.push("admonition_close", "div", -1), p.markup = u.src.slice(k, v), p.block = !0, u.parentType = D, u.lineMax = R, u.line = b + (f ? 1 : 0), !0;
    },
    {
      alt: ["paragraph", "reference", "blockquote", "list"]
    }
  ), e.renderer.rules.admonition_open = m, e.renderer.rules.admonition_title_open = m, e.renderer.rules.admonition_title_close = m, e.renderer.rules.admonition_close = m;
}, eo = Qn, to = (e, r) => {
  e.renderer.rules.heading_open = (i, t) => {
    const n = i[t], l = i[t + 1].content, d = n.markup.length;
    return r.headsRef.current.push({
      text: l,
      level: d
    }), n.map && n.level === 0 && (n.attrSet("data-line", String(n.map[0])), n.attrSet(
      "id",
      r.mdHeadingId(l, d, r.headsRef.current.length)
    )), e.renderer.renderToken(i, t, r);
  }, e.renderer.rules.heading_close = (i, t, n, l, d) => d.renderToken(i, t, n);
}, ro = to, no = (e, r) => {
  const i = e.renderer.rules.fence, t = e.utils.unescapeAll, n = /\[(\w*)(?::([\w ]*))?\]/;
  function l(h) {
    return h.info ? t(h.info).trim() : "";
  }
  function d(h) {
    const u = l(h), [s = null, C = ""] = (n.exec(u) || []).slice(1);
    return [s, C];
  }
  function o(h) {
    const u = l(h);
    return u ? u.split(/(\s+)/g)[0] : "";
  }
  const m = (h, u, s, C, w) => {
    if (h[u].hidden)
      return "";
    const [v, b] = d(h[u]);
    if (v === null)
      return i(h, u, s, C, w);
    let p, f, k, T, M = "", x = "";
    for (let H = u; H < h.length && (p = h[H], [f, k] = d(p), f === v); H++)
      p.info = p.info.replace(n, ""), p.hidden = !0, T = H - u > 0 ? "" : " checked", M += `<li><input type="radio" name="label-group-${r.editorId}-${u}"${T}><label for="group-${r.editorId}-${u}-tab-${H - u}" onclick="this.previousElementSibling.click()">${k || o(p)}</label></li>
`, x += `<input type="radio" id="group-${r.editorId}-${u}-tab-${H - u}" name="group-${r.editorId}-${u}"${T}>
` + i(h, H, s, C, w);
    return `<div class="code-tabs">
<ul>
` + M + `</ul>
` + x + "</div>";
  };
  e.renderer.rules.fence = m;
}, oo = no, lo = (e) => {
  [
    "paragraph_open",
    "table_open",
    "ordered_list_open",
    "bullet_list_open",
    "blockquote_open",
    "hr",
    "html_block",
    "fence"
  ].forEach((r) => {
    const i = e.renderer.rules[r];
    i ? e.renderer.rules[r] = (t, n, l, d, o) => {
      let m;
      const h = i(t, n, l, d, o);
      return t[n].map && t[n].level === 0 ? (m = t[n].map[0], h.replace(/^(<[^>]*)/, `$1 data-line="${m}"`)) : h;
    } : e.renderer.rules[r] = (t, n, l, d, o) => {
      let m;
      return t[n].map && t[n].level === 0 && (m = t[n].map[0], t[n].attrSet("data-line", String(m))), o.renderToken(t, n, l);
    };
  });
}, ao = (e, r) => {
  const { onHtmlChanged: i = () => {
  }, onGetCatalog: t = () => {
  } } = e, { editorConfig: n, markdownItConfig: l, markdownItPlugins: d } = z, { editorId: o, showCodeRowNumber: m, theme: h } = G(q), u = j([]), s = j(h);
  y(() => {
    s.current = h;
  }, [h]);
  const { hljsRef: C, hljsInited: w } = Un(e), { katexRef: v, katexInited: b } = Gn(e), { reRender: p, replaceMermaid: f } = qn(e), [k] = O(() => {
    const D = dr({
      html: !0,
      breaks: !0
    });
    l(D);
    const R = [
      {
        type: "katex",
        plugin: Jn,
        options: { katexRef: v }
      },
      {
        type: "image",
        plugin: ur,
        options: { figcaption: !0, classes: "md-zoom" }
      },
      {
        type: "admonition",
        plugin: eo,
        options: {}
      },
      {
        type: "taskList",
        plugin: mr,
        options: {}
      },
      {
        type: "heading",
        plugin: ro,
        options: { mdHeadingId: e.mdHeadingId, headsRef: u }
      },
      {
        type: "codeTabs",
        plugin: oo,
        options: { editorId: o }
      }
    ];
    return e.noMermaid || R.push({
      type: "mermaid",
      plugin: Wn,
      options: { themeRef: s }
    }), d(R).forEach((_) => {
      D.use(_.plugin, _.options);
    }), D.set({
      highlight: (_, K) => {
        let V;
        !e.noHighlight && C.current ? C.current.getLanguage(K) ? V = C.current.highlight(_, {
          language: K,
          ignoreIllegals: !0
        }).value : V = C.current.highlightAuto(_).value : V = k.utils.escapeHtml(_);
        const E = m ? Xt(V.trim()) : `<span class="code-block">${V.trim()}</span>`;
        return `<pre><code class="language-${K}" language=${K}>${E}</code></pre>`;
      }
    }), lo(D), D;
  }), [T, M] = O(() => e.sanitize(k.render(e.value))), x = U(() => (e.noHighlight || w) && (e.noKatex || b), [w, b]), H = j(!0);
  return y(() => {
    $.emit(o, "buildFinished", T), i(T), t(u.current), $.emit(o, "catalogChanged", u.current);
  }, [T]), y(() => {
    if (H.current) {
      H.current = !1;
      return;
    }
    const D = setTimeout(
      () => {
        u.current = [];
        const R = e.sanitize(k.render(e.value));
        M(R);
      },
      (n == null ? void 0 : n.renderDelay) !== void 0 ? n == null ? void 0 : n.renderDelay : r ? 0 : 500
    );
    return () => {
      clearTimeout(D);
    };
  }, [e.value, x, h]), y(() => {
    f();
  }, [T, p]), y(() => {
    $.on(o, {
      name: "pushCatalog",
      callback() {
        $.emit(o, "catalogChanged", u.current);
      }
    });
  }, []), { html: T };
}, io = ao, co = (e) => {
  const { previewOnly: r = !1 } = e, { editorId: i, previewTheme: t, showCodeRowNumber: n } = G(q), { html: l } = io(e, !!r);
  return Vn(e, l), _n(e, l), /* @__PURE__ */ N(pe, { children: [
    /* @__PURE__ */ c(
      "div",
      {
        id: `${i}-preview-wrapper`,
        className: `${a}-preview-wrapper`,
        "data-show": e.setting.preview,
        children: /* @__PURE__ */ c(
          "article",
          {
            id: `${i}-preview`,
            className: ve([
              `${a}-preview`,
              `${t}-theme`,
              n && `${a}-scrn`
            ]),
            dangerouslySetInnerHTML: { __html: l }
          }
        )
      },
      "content-preview-wrapper"
    ),
    !r && /* @__PURE__ */ c(
      "div",
      {
        id: `${i}-html-wrapper`,
        className: `${a}-preview-wrapper`,
        "data-show": e.setting.htmlPreview,
        children: /* @__PURE__ */ c("div", { className: `${a}-html`, children: l })
      },
      "html-preview-wrapper"
    )
  ] });
}, so = (e) => {
  const { editorId: r } = G(q), [i, t] = O(""), { inputWrapperRef: n, codeMirrorUt: l } = Rn(e);
  return Qr(e, i, l), /* @__PURE__ */ N("div", { className: `${a}-content`, children: [
    /* @__PURE__ */ c("div", { className: `${a}-input-wrapper`, ref: n }),
    /* @__PURE__ */ c(
      co,
      {
        value: e.value,
        setting: e.setting,
        onHtmlChanged: (d) => {
          t(d), e.onHtmlChanged(d);
        },
        onGetCatalog: e.onGetCatalog,
        mdHeadingId: e.mdHeadingId,
        noMermaid: e.noMermaid,
        sanitize: e.sanitize,
        noKatex: e.noKatex,
        formatCopiedText: e.formatCopiedText,
        noHighlight: e.noHighlight
      },
      "display-editor"
    ),
    e.catalogVisible && /* @__PURE__ */ c(
      Yt,
      {
        theme: e.theme,
        className: `${a}-catalog-editor`,
        editorId: r,
        mdHeadingId: e.mdHeadingId
      },
      "internal-catalog"
    )
  ] });
}, uo = Te.memo(so), mo = ({ modelValue: e }) => {
  const { usedLanguageText: r } = G(q);
  return U(() => {
    var i;
    return /* @__PURE__ */ N("div", { className: `${a}-footer-item`, children: [
      /* @__PURE__ */ c("label", { className: `${a}-footer-label`, children: `${(i = r.footer) == null ? void 0 : i.markdownTotal}:` }),
      /* @__PURE__ */ c("span", { children: e.length || 0 })
    ] });
  }, [r, e]);
}, ho = (e) => /* @__PURE__ */ c(
  "div",
  {
    className: ve([
      `${a}-checkbox`,
      e.checked && `${a}-checkbox-checked`
    ]),
    onClick: () => {
      e.onChange(!e.checked);
    }
  }
), go = (e) => {
  var i;
  const { usedLanguageText: r } = G(q);
  return U(() => {
    var t;
    return /* @__PURE__ */ N("div", { className: `${a}-footer-item`, children: [
      /* @__PURE__ */ c(
        "label",
        {
          className: `${a}-footer-label`,
          onClick: () => {
            e.onScrollAutoChange(!e.scrollAuto);
          },
          children: (t = r.footer) == null ? void 0 : t.scrollAuto
        }
      ),
      /* @__PURE__ */ c(ho, { checked: e.scrollAuto, onChange: e.onScrollAutoChange })
    ] });
  }, [(i = r.footer) == null ? void 0 : i.scrollAuto, e]);
}, bo = (e) => {
  const r = F(
    (n) => {
      if (rr.includes(n))
        switch (n) {
          case "markdownTotal":
            return /* @__PURE__ */ c(mo, { modelValue: e.modelValue }, "markdown-total");
          case "scrollSwitch":
            return /* @__PURE__ */ c(
              go,
              {
                scrollAuto: e.scrollAuto,
                onScrollAutoChange: e.onScrollAutoChange
              },
              "scroll-auto"
            );
        }
      else
        return e.defFooters[n] || "";
    },
    [e.modelValue, e.scrollAuto, e.onScrollAutoChange, e.defFooters]
  ), [i, t] = U(() => {
    const n = e.footers.indexOf("="), l = n === -1 ? e.footers : e.footers.slice(0, n), d = n === -1 ? [] : e.footers.slice(n, Number.MAX_SAFE_INTEGER);
    return [
      l.map((o) => r(o)),
      d.map((o) => r(o))
    ];
  }, [e.footers, r]);
  return /* @__PURE__ */ N("div", { className: `${a}-footer`, children: [
    /* @__PURE__ */ c("div", { className: `${a}-footer-left`, children: i }),
    /* @__PURE__ */ c("div", { className: `${a}-footer-right`, children: t })
  ] });
}, fo = Te.memo(bo), q = Gt({
  editorId: "",
  tabWidth: 2,
  theme: "light",
  highlight: {
    css: "",
    js: ""
  },
  showCodeRowNumber: !1,
  usedLanguageText: we["zh-CN"],
  previewTheme: "default"
}), po = zt((e, r) => {
  const {
    modelValue: i = L.modelValue,
    theme: t = L.theme,
    className: n = L.className,
    toolbars: l = L.toolbars,
    toolbarsExclude: d = L.toolbarsExclude,
    defToolbars: o = L.defToolbars,
    editorId: m = L.editorId,
    tabWidth: h = L.tabWidth,
    showCodeRowNumber: u = L.showCodeRowNumber,
    previewTheme: s = L.previewTheme,
    noPrettier: C = L.noPrettier,
    tableShape: w = L.tableShape,
    noMermaid: v = L.noMermaid,
    noKatex: b = L.noKatex,
    placeholder: p = L.placeholder,
    onChange: f = L.onChange,
    onHtmlChanged: k = L.onHtmlChanged,
    onGetCatalog: T = L.onGetCatalog,
    sanitize: M = L.sanitize,
    onError: x = L.onError,
    mdHeadingId: H = L.mdHeadingId,
    footers: D = L.footers,
    defFooters: R = L.defFooters,
    noIconfont: _ = L.noIconfont,
    noUploadImg: K = L.noUploadImg,
    noHighlight: V = L.noHighlight
  } = e, [E] = O(() => ({
    editorId: m,
    noKatex: b,
    noMermaid: v,
    noPrettier: C,
    noUploadImg: K,
    noIconfont: _,
    noHighlight: V
  })), [Z, X] = O(() => ({
    scrollAuto: e.scrollAuto === void 0 ? !0 : e.scrollAuto
  })), ae = F(
    (A) => {
      X((P) => ({
        ...P,
        scrollAuto: A
      }));
    },
    [X]
  );
  Sr(e, E), Hr(E), Ir(e, E), Mr(E.editorId, x);
  const ne = Er(e, E), [J, Q, S, I] = Ar(e);
  return Dr(r, E, ne, S, I), y(() => () => {
    $.clear(m);
  }, []), /* @__PURE__ */ c(
    q.Provider,
    {
      value: {
        editorId: E.editorId,
        tabWidth: h,
        theme: t,
        highlight: J,
        showCodeRowNumber: u,
        usedLanguageText: Q,
        previewTheme: s
      },
      children: /* @__PURE__ */ N(
        "div",
        {
          id: E.editorId,
          className: ve([
            a,
            n,
            t === "dark" && `${a}-dark`,
            S.fullscreen || S.pageFullscreen ? `${a}-fullscreen` : ""
          ]),
          style: e.style,
          children: [
            /* @__PURE__ */ c(
              Zr,
              {
                noPrettier: E.noPrettier,
                toolbars: l,
                toolbarsExclude: d,
                setting: S,
                updateSetting: I,
                tableShape: w,
                defToolbars: o,
                noUploadImg: E.noUploadImg,
                showToolbarName: e.showToolbarName
              }
            ),
            /* @__PURE__ */ c(
              uo,
              {
                value: i,
                onChange: f,
                setting: S,
                mdHeadingId: H,
                onHtmlChanged: k,
                onGetCatalog: T,
                sanitize: M,
                noMermaid: E.noMermaid,
                noPrettier: E.noPrettier,
                noHighlight: E.noHighlight,
                placeholder: p,
                noKatex: E.noKatex,
                scrollAuto: Z.scrollAuto,
                formatCopiedText: e.formatCopiedText,
                autoFocus: e.autoFocus,
                disabled: e.disabled,
                readOnly: e.readOnly,
                maxLength: e.maxLength,
                autoDetectCode: e.autoDetectCode,
                onBlur: e.onBlur,
                onFocus: e.onFocus,
                onInput: e.onInput,
                completions: e.completions,
                catalogVisible: ne,
                theme: e.theme
              }
            ),
            (D == null ? void 0 : D.length) > 0 && /* @__PURE__ */ c(
              fo,
              {
                modelValue: i,
                footers: D,
                defFooters: R,
                scrollAuto: Z.scrollAuto,
                onScrollAutoChange: ae
              }
            )
          ]
        }
      )
    }
  );
}), Bo = po;
export {
  co as C,
  de as D,
  Bo as E,
  Ar as a,
  q as b,
  Lr as u
};
